msgid ""
msgstr ""
"POT-Creation-Date: 2026-06-09 03:29+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es-MX\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"

#. placeholder {0}: conversation.messagesCount
#: app/frontend/pages/v2/contacts/show.tsx
msgid " · {0} {messagesNoun}"
msgstr " · {0} {messagesNoun}"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid " · approved by Meta"
msgstr " · aprobado por Meta"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid " · awaiting Meta"
msgstr " · pendiente de Meta"

#. placeholder {0}: stage.dealsCount
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "· {0} deal"
msgstr "· {0} oportunidad"

#. placeholder {0}: stage.dealsCount
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "· {0} deals"
msgstr "· {0} oportunidades"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "· edits save to the note"
msgstr "· los cambios se guardan en la nota"

#: app/frontend/components/v2/voice/after-call-subview-header.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "‹ Back"
msgstr "‹ Atrás"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "\"{draft}\" — ready to send the moment they reply."
msgstr "\"{draft}\" — listo para enviar en el momento que responda."

#: app/frontend/lib/delete-prompt-copy.ts
msgid "\"{quoted}\" and its history will be permanently deleted."
msgstr "\"{quoted}\" y su historial se eliminarán permanentemente."

#: app/frontend/lib/delete-prompt-copy.ts
msgid "\"{quoted}\" will be removed."
msgstr "\"{quoted}\" será eliminado."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "(dev only)"
msgstr "(solo dev)"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "(me)"
msgstr "(yo)"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "(no value needed)"
msgstr "(no se requiere valor)"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "(optional)"
msgstr "(opcional)"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "(this template has no body)"
msgstr "(esta plantilla no tiene contenido)"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "{{{0}}} — AI filled"
msgstr "{{{0}}} — rellenado por IA"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "{{{0}}} — AI filling from the call…"
msgstr "{{{0}}} — IA completando desde la llamada…"

#. placeholder {0}: current.trialDaysLeft
#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "{0, plural, one {# day left} other {# days left}}"
msgstr "{0, plural, one {# día restante} other {# días restantes}}"

#. placeholder {0}: conversation.messagesCount
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# mensaje} other {# mensajes}}"

#. placeholder {0}: preset.label
#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "{0}"
msgstr "{0}"

#. placeholder {0}: employee?.name ?? t`Teammate`
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "{0} - Team - Conecto"
msgstr "{0} - Equipo - Conecto"

#. placeholder {0}: formatActivityCount(count, t)
#. placeholder {1}: formatDateLabel(iso)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} · {1}"
msgstr "{0} · {1}"

#. placeholder {0}: formatActivityCount(count, t)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} · oldest {oldestLateDays} {dayNoun} late"
msgstr "{0} · más antiguo {oldestLateDays} {dayNoun} vencido"

#. placeholder {0}: format || "MEDIA"
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{0} · the sample Meta reviews"
msgstr "{0} · las revisiones de ejemplo de Meta"

#. placeholder {0}: deal.created.at
#. placeholder {1}: deal.created.by
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "{0} by {1}"
msgstr "{0} por {1}"

#. placeholder {0}: formatEmployeeCount(company.employeeCount)
#. placeholder {0}: formatEmployeeCount(deal.company.employeeCount)
#. placeholder {0}: formatInteger(company.employeeCount)
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/show-hero.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "{0} employees"
msgstr "{0} empleados"

#. placeholder {0}: kpis.closedWon.lifetimeLabel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{0} lifetime"
msgstr "{0} de vida útil"

#. placeholder {0}: employee.numbersCount
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "{0} numbers"
msgstr "{0} números"

#. placeholder {0}: stats.voiceEnabled
#. placeholder {1}: stats.members
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "{0} of {1} teammate have voice enabled."
msgstr "{0} de {1} compañero tiene voz habilitada."

#. placeholder {0}: stats.voiceEnabled
#. placeholder {1}: stats.members
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "{0} of {1} teammates have voice enabled."
msgstr "{0} de {1} compañeros tienen voz habilitada."

#. placeholder {0}: company.openDealsCount
#. placeholder {0}: deal.company.openDealsCount
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "{0} other deals"
msgstr "{0} otras oportunidades"

#. placeholder {0}: counts.overdue
#. placeholder {1}: counts.today
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} overdue · {1} to do"
msgstr "{0} vencidas · {1} pendientes"

#. placeholder {0}: kpis.openDeals.pipelineLabel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{0} pipeline"
msgstr "{0} embudo"

#. placeholder {0}: selectedIds.length
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "{0} selected"
msgstr "{0} seleccionado"

#. placeholder {0}: stage.name
#: app/frontend/components/v2/deals/deal-column.tsx
msgid "{0} stage"
msgstr "{0} etapa"

#. placeholder {0}: stages.length
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "{0} stages"
msgstr "{0} etapas"

#. placeholder {0}: number.assigneeCount
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "{0} teammates"
msgstr "{0} compañeros"

#. placeholder {0}: formatActivityCount(count, t)
#. placeholder {1}: formatDateLabel(rangeEnd)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} through {1}"
msgstr "{0} hasta {1}"

#. placeholder {0}: counts.today
#. placeholder {1}: counts.overdue
#. placeholder {2}: counts.completedToday
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} to do · {1} overdue · {2} completed earlier"
msgstr "{0} pendientes · {1} vencidas · {2} completadas antes"

#. placeholder {0}: counts.unread
#. placeholder {1}: counts.all
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "{0} unread of {1} total"
msgstr "{0} sin leer de {1} en total"

#. placeholder {0}: selected.variables.length
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "{0} variables auto-filled"
msgstr "{0} variables rellenadas automáticamente"

#. placeholder {0}: conversation.contact.name
#. placeholder {1}: conversation.contact.name.split(" ")[0] ?? "them"
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
msgid "{0}'s thread will be hidden from every teammate's inbox. New messages from {1} will bring it back automatically."
msgstr "El hilo de {0} se ocultará de la bandeja de entrada de todos tus compañeros. Los nuevos mensajes de {1} lo traerán de vuelta automáticamente."

#. placeholder {0}: Math.round( (stats.linkedToDealCount / stats.totalContacts) * 100, )
#: app/frontend/pages/v2/contacts/index.tsx
msgid "{0}% of total"
msgstr "{0}% del total"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "{activeCount} active"
msgstr "{activeCount} activo"

#: app/frontend/components/v2/inbox/inbox-list.tsx
msgid "{allCount} active"
msgstr "{allCount} activo"

#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "{answererCount} selected"
msgstr "{answererCount} seleccionado"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
msgid "{channelsCount} {channelNoun}"
msgstr "{channelsCount} {channelNoun}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
msgid "{charCount} chars"
msgstr "{charCount} caracteres"

#: app/frontend/pages/v2/today/show.tsx
msgid "{count} {noun}"
msgstr "{count} {noun}"

#: app/frontend/pages/v2/companies/index.tsx
msgid "{count} companies need enrichment this week."
msgstr "{count} empresas necesitan enriquecimiento esta semana."

#: app/frontend/components/v2/deals/deal-card.tsx
msgid "{count} conversations need a reply"
msgstr "{count} conversaciones necesitan respuesta"

#: app/frontend/components/v2/companies/index-list.tsx
msgid "{count} deals"
msgstr "{count} oportunidades"

#: app/frontend/pages/v2/today/show.tsx
msgid "{count} done · clears at midnight"
msgstr "{count} completadas · se limpia a medianoche"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "{count} fields needed"
msgstr "{count} campos requeridos"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{count} of {BUTTONS_MAX} used · quick replies group together, away from URL / call buttons"
msgstr "{count} de {BUTTONS_MAX} utilizado · las respuestas rápidas se agrupan juntas, separadas de botones de URL/llamada"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "{deepFilterCount} active filter"
msgstr "{deepFilterCount} filtro activo"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "{deepFilterCount} active filters"
msgstr "{deepFilterCount} filtros activos"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "{diffMin}m ago"
msgstr "hace {diffMin}m"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "{extra} more"
msgstr "{extra} más"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "{fieldCount} field"
msgstr "{fieldCount} campo"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "{fieldCount} fields"
msgstr "{fieldCount} campos"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "{firstName} hasn't replied in over 24 hours. WhatsApp only allows freeform messages within 24 hours of the customer's last message — to keep talking, send an approved template."
msgstr "{firstName} no ha respondido en más de 24 horas. WhatsApp solo permite mensajes libres dentro de 24 horas del último mensaje del cliente — para seguir hablando, envía una plantilla aprobada."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "{firstName}'s deals"
msgstr "Oportunidades de {firstName}"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "{label} — coming soon"
msgstr "{label} — próximamente"

#: app/frontend/components/v2/contacts/row-actions.tsx
msgid "{label} ({disabledTitle})"
msgstr "{label} ({disabledTitle})"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "{label} (coming soon)"
msgstr "{label} (próximamente)"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{label} (wraps selection with {marker})"
msgstr "{label} (envuelve la selección con {marker})"

#: app/frontend/components/v2/settings/phone-numbers/buy/capability-toggle-row.tsx
msgid "{label} capability"
msgstr "capacidad {label}"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "{left} of {editsLimit} edits left in this 30-day window"
msgstr "{left} de {editsLimit} ediciones restantes en esta ventana de 30 días"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{open} open"
msgstr "{open} abierto"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "{selectedCount} of {itemCount} selected"
msgstr "{selectedCount} de {itemCount} seleccionado"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "{selectedCount} selected"
msgstr "{selectedCount} seleccionado"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "{triggerLabel}"
msgstr "{triggerLabel}"

#. placeholder {0}: variableCount === 1 ? "" : "s"
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{variableCount} variable{0} · {charCount} / {BODY_MAX} chars"
msgstr "{variableCount} variable{0} · {charCount} / {BODY_MAX} caracteres"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{won} won"
msgstr "{won} ganadas"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "/ seat / month"
msgstr "/ asiento / mes"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "© 2026 Conecto. All rights reserved."
msgstr "© 2026 Conecto. Todos los derechos reservados."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "← Back"
msgstr "← Atrás"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "↻ Reopen"
msgstr "↻ Reabrir"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "+ Add"
msgstr "+ Agregar"

#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "+ Add details"
msgstr "+ Agregar detalles"

#: app/frontend/components/v2/inbox/opportunity-actions-panel.tsx
msgid "+ Link existing"
msgstr "+ Vincular existente"

#: app/frontend/components/v2/inbox/opportunity-actions-panel.tsx
msgid "+ New opportunity"
msgstr "+ Nueva oportunidad"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "+ New shortcut"
msgstr "+ Nuevo atajo"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "+ Open chat"
msgstr "+ Abrir chat"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "+ Save as view"
msgstr "+ Guardar como vista"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "+1 555 0123"
msgstr "+1 555 0123"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "+1 555 123 4567"
msgstr "+1 555 123 4567"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "⌘+Enter to save"
msgstr "⌘+Enter para guardar"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "⌘+Enter to send · Esc to close"
msgstr "⌘+Enter para enviar · Esc para cerrar"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "★ AI draft available"
msgstr "★ borrador de IA disponible"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "★ AI suggests · current"
msgstr "★ IA sugiere · actual"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "✓ AUTO"
msgstr "✓ AUTOMÁTICO"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "✨ from your call"
msgstr "✨ de tu llamada"

#: app/frontend/components/v2/inbox/inbox-list.tsx
msgid "1 active"
msgstr "1 activo"

#: app/frontend/pages/v2/companies/index.tsx
msgid "1 company needs enrichment this week."
msgstr "1 empresa necesita enriquecimiento esta semana."

#: app/frontend/components/v2/companies/index-list.tsx
msgid "1 deal"
msgstr "1 oportunidad"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "1 device"
msgstr "1 dispositivo"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "1 field needed"
msgstr "1 campo requerido"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "1 more"
msgstr "1 más"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "1 number"
msgstr "1 número"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "1 other deal"
msgstr "1 otra oportunidad"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "1 stage"
msgstr "1 etapa"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "1 teammate"
msgstr "1 compañero"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "1 variable auto-filled"
msgstr "1 variable rellenada automáticamente"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
msgid "2 months free"
msgstr "2 meses gratis"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "2-yr renewal"
msgstr "renovación de 2 años"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "24 deals · $1.2M"
msgstr "24 oportunidades · $1.2M"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "24-hour window open — freeform messages allowed."
msgstr "ventana de 24 horas abierta — se permiten mensajes sin restricciones."

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "24h window open"
msgstr "ventana de 24h abierta"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "3 variables auto-filled"
msgstr "3 variables rellenadas automáticamente"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "3 vars auto-filled"
msgstr "3 vars rellenadas automáticamente"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "5 of 12 done"
msgstr "5 de 12 completados"

#: app/frontend/components/v2/landing/integrations.tsx
msgid "A CRM that fits your stack"
msgstr "Un CRM que se adapta a tu pila"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "A map preview sits at the top of the message and opens the recipient's map app. Nothing to configure on the template."
msgstr "Una vista previa del mapa se coloca en la parte superior del mensaje y abre la aplicación de mapas del destinatario. nada que configurar en la plantilla."

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "About"
msgstr "Acerca de"

#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Accept"
msgstr "Aceptar"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Access"
msgstr "Acceso"

#: app/frontend/lib/settings-nav.ts
msgid "Account"
msgstr "Cuenta"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Account menu"
msgstr "Menú de cuenta"

#. placeholder {0}: stats.activeConversationContactsCount
#: app/frontend/pages/v2/contacts/index.tsx
msgid "across {0} {acrossContactsNoun}"
msgstr "en {0} {acrossContactsNoun}"

#. placeholder {0}: kpis.conversations.channelsCount
#: app/frontend/pages/v2/contacts/show.tsx
msgid "across {0} {channelNoun}"
msgstr "en {0} {channelNoun}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Active"
msgstr "Activo"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Active conversations"
msgstr "Conversaciones activas"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Active deals"
msgstr "Oportunidades activas"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "Active numbers"
msgstr "Números activos"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Active sessions"
msgstr "Sesiones activas"

#: app/frontend/pages/v2/today/show.tsx
msgid "activities"
msgstr "actividades"

#: app/frontend/pages/v2/today/show.tsx
msgid "activity"
msgstr "actividad"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Activity"
msgstr "Actividad"

#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Activity facets"
msgstr "Facetas de actividad"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Activity filters"
msgstr "Filtros de actividad"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Add"
msgstr "Agregar"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add a header, footer, or buttons."
msgstr "Agrega un encabezado, pie de página o botones."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Add a name + description when editing"
msgstr "Agrega un nombre + descripción al editar"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Add a note"
msgstr "Agregar una nota"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Add a note about this deal…"
msgstr "Agrega una nota sobre esta oportunidad…"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Add a note for this call…"
msgstr "Agrega una nota para esta llamada…"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Add a note…"
msgstr "Agregar una nota…"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add a number"
msgstr "Agregar un número"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add a number below to start routing calls and messages here."
msgstr "Agrega un número abajo para empezar a enrutar llamadas y mensajes aquí."

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add a payment method"
msgstr "Agregar un método de pago"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add a payment method to buy numbers"
msgstr "Agrega un método de pago para comprar números"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Add a quick note…"
msgstr "Agregar una nota rápida…"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add an email or company and we’ll enrich the rest — from there and your conversations."
msgstr "Agrega un correo o empresa y completamos el resto — a partir de eso y de tus conversaciones."

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Add another"
msgstr "Agregar otro"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Add button"
msgstr "Agregar botón"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add buttons"
msgstr "Agregar botones"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add card and continue"
msgstr "Agregar tarjeta y continuar"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Add contact"
msgstr "Agregar contacto"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add email or company"
msgstr "Agregar correo o empresa"

#: app/frontend/lib/settings-nav.ts
msgid "Add fields to contacts and deals."
msgstr "Agrega campos a contactos y oportunidades."

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Add filter"
msgstr "Agregar filtro"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Add follow-up"
msgstr "Agregar seguimiento"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add footer"
msgstr "Agregar pie de página"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Add from {companyName}"
msgstr "Agregar de {companyName}"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add header"
msgstr "Agregar encabezado"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Add new contact (coming soon)"
#~ msgstr "Agregar nuevo contacto (próximamente)"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Add new contact…"
#~ msgstr "Agregar nuevo contacto…"

#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Add next step"
msgstr "Agregar siguiente paso"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Add note"
msgstr "Agregar nota"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add number"
msgstr "Agregar número"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Add one {{1}} to personalize the link — Meta needs a sample value."
msgstr "Agrega uno {{1}} para personalizar el enlace — Meta necesita un valor de muestra."

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Add role"
msgstr "Agregar rol"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add someone you’re talking to"
msgstr "Agrega a alguien con quien estés hablando"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Add stage"
msgstr "Agregar etapa"

#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Add stages to your pipeline to start tracking deals through your sales process."
msgstr "Agrega etapas a tu embudo para empezar a rastrear oportunidades a través de tu proceso de ventas."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Add the numbers"
msgstr "Agrega los números"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Add to {0}"
msgstr "Agregar a {0}"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Add to history"
msgstr "Agregar al historial"

#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Add value"
msgstr "Agregar valor"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
msgid "Adding…"
msgstr "Agregando…"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Admin"
msgstr "Administrador"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Admin override coming soon. For now teammates set this themselves from their own status strip."
msgstr "Anulación de administrador próximamente. por ahora los compañeros de equipo lo configuran ellos mismos desde su propia barra de estado."

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
msgid "Admins"
msgstr "Administradores"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "After call"
msgstr "Después de la llamada"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
msgid "Agents"
msgstr "Agentes"

#: app/frontend/components/v2/messages/outbound-sender-avatar.tsx
#: app/frontend/components/v2/today/mobile-tabs.tsx
msgid "AI"
msgstr "IA"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "AI · may contain errors"
msgstr "IA · puede contener errores"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "AI actions"
msgstr "Acciones de IA"

#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "AI assistants"
msgstr "Asistentes de IA"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "AI attempted to send"
msgstr "IA intentó enviar"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "AI behavior"
msgstr "Comportamiento de IA"

#. placeholder {0}: stats.newThisWeek
#: app/frontend/pages/v2/contacts/index.tsx
msgid "AI captured {0} new {newNoun} this week."
msgstr "La IA capturó {0} nuevos {newNoun} esta semana."

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "AI captured {count} new contacts this week from inbound conversations."
msgstr "La IA capturó {count} nuevos contactos esta semana de conversaciones entrantes."

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "AI captured 1 new contact this week."
msgstr "La IA capturó 1 nuevo contacto esta semana."

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "AI drafted from the call"
msgstr "IA redactó de la llamada"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "AI hasn't needed to step in yet — it'll show up here as it helps."
msgstr "La IA aún no ha necesitado intervenir — aparecerá aquí cuando ayude."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "AI is listening · live transcript"
msgstr "La IA está escuchando · transcripción en vivo"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "AI needs you"
msgstr "La IA te necesita"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "AI on duty"
msgstr "IA de servicio"

#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "AI paused"
msgstr "IA pausada"

#: app/frontend/components/v2/deals/ai-paused-banner.tsx
#: app/frontend/components/v2/deals/ai-paused-banner.tsx
msgid "AI paused for your call"
msgstr "IA pausada para tu llamada"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "AI picked this deal — confirm it's the right one."
msgstr "La IA eligió esta oportunidad — confirma que es la correcta."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "AI replied for you"
msgstr "La IA respondió por ti"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "AI suggested"
msgstr "IA sugirió"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "AI suggested · dismissed"
msgstr "IA sugirió · desestimado"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "AI suggests"
msgstr "La IA sugiere"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "AI suggests a deal"
msgstr "La IA sugiere una oportunidad"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "AI suggests prompts during the call."
msgstr "La IA sugiere indicaciones durante la llamada."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "AI summary"
msgstr "Resumen de IA"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "AI thinks this call advanced the stage"
msgstr "La IA cree que esta llamada avanzó la etapa"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "AI will suggest a starter template once a contact is selected."
msgstr "La IA sugerirá una plantilla de inicio una vez que se seleccione un contacto."

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "AI will suggest one once it learns more."
msgstr "La IA sugerirá una una vez que aprenda más."

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "AI will transcribe this call"
msgstr "La IA transcribirá esta llamada"

#: app/frontend/components/v2/companies/pill.tsx
msgid "AI working"
msgstr "IA trabajando"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "AI-detected"
msgstr "Detectado por IA"

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "AI-native CRM"
msgstr "CRM nativo de IA"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/types/v2/search.ts
msgid "All"
msgstr "Todos"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "All deals"
msgstr "Todas las oportunidades"

#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "All teammates"
msgstr "Todos los compañeros de equipo"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "All templates"
msgstr "Todas las plantillas"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Already have an account?"
msgstr "¿ya tienes una cuenta?"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Already suggested on this call"
msgstr "Ya sugerido en esta llamada"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Also at {companyName}"
#~ msgstr "También en {companyName}"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Also dismiss this suggestion?"
msgstr "¿Descartar también esta sugerencia?"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Also linked"
#~ msgstr "También vinculado"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-row.tsx
msgid "Analyzing call…"
msgstr "Analizando llamada…"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Analyzing…"
msgstr "Analizando…"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "and"
msgstr "y"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
msgid "Annual"
msgstr "Anual"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Answer"
msgstr "Responder"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Answer call"
msgstr "Responder llamada"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Answers"
msgstr "Respuestas"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
msgid "Answers on"
msgstr "Contesta en"

#: app/frontend/lib/settings-nav.ts
msgid "API keys"
msgstr "Claves API"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Apple sign-in is coming soon"
msgstr "Inicio de sesión con Apple próximamente"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply"
msgstr "Aplicar"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Apply · {0} {contactsNoun}"
msgstr "Aplicar · {0} {contactsNoun}"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply · {0} deal"
msgstr "Aplicar · {0} oportunidad"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply · {0} deals"
msgstr "Aplicar · {0} oportunidades"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Approve before send"
msgstr "Aprobar antes de enviar"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Approved"
msgstr "Aprobado"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "APPROVED"
msgstr "APROBADO"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Approved {approvedAge}"
msgstr "Aprobado {approvedAge}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Approved templates"
msgstr "Plantillas aprobadas"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "April"
msgstr "Abril"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Archive"
msgstr "Archivar"

#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Archive conversation"
msgstr "Archivar conversación"

#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
msgid "Archive this conversation?"
msgstr "¿Archivar esta conversación?"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "As {recipientLabel} will see it"
msgstr "Como lo verá {recipientLabel}"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
msgid "Ask AI"
msgstr "Pregunta a la IA"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Assign"
msgstr "Asignar"

#: app/frontend/components/v2/contacts/contact-assignees-cell.tsx
#: app/frontend/components/v2/settings/phone-numbers/answerer-cell.tsx
msgid "Assign →"
msgstr "Asignar →"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "Assign conversation"
msgstr "Asignar conversación"

#: app/frontend/lib/phone-number-display.ts
msgid "Assigned"
msgstr "Asignado"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Assigned conversations"
msgstr "Conversaciones asignadas"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
msgid "Assigned to"
msgstr "Asignado a"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "ASSIGNED TO"
#~ msgstr ""

#. placeholder {0}: assignee.name
#: app/frontend/components/v2/inbox/chat-header.tsx
msgid "Assigned to {0}"
msgstr "Asignado a {0}"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Assigned to me"
msgstr "Asignado a mí"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Assignee"
msgstr "Asignado"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "at"
msgstr "en"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Attach"
msgstr "Adjuntar"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attach {selectedCount}"
msgstr "Adjuntar {selectedCount}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Attach file"
msgstr "Adjuntar archivo"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Attach image"
msgstr "Adjuntar imagen"

#. placeholder {0}: offer.dealName
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attach to {0}?"
msgstr "¿Adjuntar a {0}?"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attaching…"
msgstr "Adjuntando…"

#: app/frontend/lib/settings-nav.ts
msgid "Audit log"
msgstr "Registro de auditoría"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "August"
msgstr "Agosto"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Auth"
msgstr "Autenticación"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Auto-escalate"
msgstr "Escalado automático"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Auto-transcribed · tap a line to seek"
msgstr "Transcrito automáticamente · toca una línea para buscar"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/lib/settings-nav.ts
msgid "Automations"
msgstr "Automatizaciones"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Availability"
msgstr "Disponibilidad"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Available"
msgstr "Disponible"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Available for calls"
msgstr "Disponible para llamadas"

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Avg call duration"
msgstr "Duración promedio de llamada"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Awaiting enrichment"
msgstr "Esperando enriquecimiento"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Away"
msgstr "Ausente"

#: app/frontend/components/v2/chrome/smart-back-link.tsx
#: app/frontend/components/v2/companies/page-shell.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/sub-sheet-header.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/voice/after-call-subview-header.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Back"
msgstr "Atrás"

#. placeholder {0}: fallbackLabel.toLowerCase()
#: app/frontend/components/v2/chrome/smart-back-link.tsx
msgid "Back to {0}"
msgstr "Atrás a {0}"

#: app/frontend/pages/v2/deals/show.tsx
msgid "Back to deals"
msgstr "Atrás a oportunidades"

#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Back to filters"
msgstr "Atrás a filtros"

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Back to inbox"
msgstr "Atrás a inbox"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Basics"
msgstr "Básico"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Before you resubmit"
msgstr "Antes de volver a enviar"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Before you submit"
msgstr "Antes de enviar"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Best matches"
msgstr "Mejores coincidencias"

#. placeholder {0}: plan.annual!.totalFormatted
#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Billed annually · {0}/yr"
msgstr "Facturado anualmente · {0}/año"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Billed monthly"
msgstr "Facturado mensualmente"

#: app/frontend/lib/settings-nav.ts
msgid "Billing"
msgstr "Facturación"

#: app/frontend/components/v2/settings/usage/period-toggle.tsx
msgid "Billing period"
msgstr "Período de facturación"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Body"
msgstr "Cuerpo"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Body doesn't include promotional copy that could mis-classify the template"
msgstr "El cuerpo no incluye contenido promocional que pudiera mal clasificar la plantilla"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Body status"
msgstr "Estado del cuerpo"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Body still under 1024 characters"
msgstr "Cuerpo todavía bajo 1024 caracteres"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Body under 1024 characters"
msgstr "Cuerpo bajo 1024 caracteres"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Bold"
msgstr "Negrita"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Book a demo"
msgstr "Agendar una demostración"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "Breadcrumb"
msgstr "Ruta de navegación"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Bring back"
msgstr "Traer de vuelta"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Browse all countries →"
msgstr "Explorar todos los países →"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Bulleted list"
msgstr "Lista con viñetas"

#: app/frontend/lib/settings-nav.ts
msgid "Business name, branding, and time zone."
msgstr "Nombre de la empresa, marca y zona horaria."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Business number"
msgstr "Número de empresa"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Busy"
msgstr "Ocupado"

#: app/frontend/lib/voice-disposition.ts
msgid "Busy — couldn't connect"
msgstr "Ocupado — no se pudo conectar"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Button text"
msgstr "Texto del botón"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Button type"
msgstr "Tipo de botón"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Buttons"
msgstr "Botones"

#: app/frontend/components/v2/settings/phone-numbers/buy-number-button.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Buy a number"
msgstr "Comprar un número"

#. placeholder {0}: stepIndex + 1
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
msgid "BUY A NUMBER · STEP {0} OF {totalSteps} · {crumb}"
msgstr "COMPRAR UN NÚMERO · PASO {0} DE {totalSteps} · {crumb}"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Buy a number to start making calls, sending SMS, or routing WhatsApp through your business. You can assign it to a teammate or let AI answer."
msgstr "Compra un número para empezar a hacer llamadas, enviar SMS o enrutar WhatsApp por tu empresa. Puedes asignarlo a un compañero o dejar que la IA responda."

#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "Buy number"
msgstr "Comprar número"

#: app/frontend/lib/settings-nav.ts
msgid "Buy numbers and assign answerers."
msgstr "Compra números y asigna responsables de responder."

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Buy your first number"
msgstr "Compra tu primer número"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "By AI"
msgstr "Por IA"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Calculating your total…"
msgstr "Calculando tu total…"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/row-actions.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/header-call-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/softphone.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Call"
msgstr "Llamada"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/header-call-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Call ({disabledReason})"
msgstr "Llamada ({disabledReason})"

#. placeholder {0}: contact.phone
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Call {0}"
msgstr "Llamar a {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Call button phone number"
msgstr "Número de teléfono del botón de llamada"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Call button text"
msgstr "Texto del botón de llamada"

#: app/frontend/components/v2/voice/call-transcript-overlay.tsx
msgid "Call detail"
msgstr "Detalle de llamada"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Call ended"
msgstr "Llamada finalizada"

#. placeholder {0}: formatDuration(voiceCall.durationSeconds ?? 0)
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call ended · {0}"
msgstr "Llamada terminada · {0}"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call note"
msgstr "Nota de llamada"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call outcome"
msgstr "Resultado de la llamada"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Call phone"
msgstr "Teléfono de llamada"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Call too short to summarize"
msgstr "Llamada muy corta para resumir"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Call with {name}"
msgstr "Llamada con {name}"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Calling, recording, and AI assist for this teammate."
msgstr "Llamadas, grabación e IA para este compañero de equipo."

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Calling…"
msgstr "Llamando…"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Calls"
msgstr "Llamadas"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Calls go to voicemail, messages queue"
msgstr "Las llamadas van al buzón de voz, los mensajes se encolan"

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Calls this week"
msgstr "Llamadas esta semana"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
msgid "Camera"
msgstr "Cámara"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Can edit AI behavior"
msgstr "Puede editar el comportamiento de la IA"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Can invite teammates"
msgstr "Puede invitar a compañeros de equipo"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Can't message {firstName} on WhatsApp yet"
msgstr "Aún no puedes enviar mensajes a {firstName} en WhatsApp"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/filters/saved-view-list.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/mobile-row-inline-editor.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Cancel"
msgstr "Cancelar"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Cancel template"
msgstr "Cancelar plantilla"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Cancel watch"
msgstr "Dejar de vigilar"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Capabilities"
msgstr "Capacidades"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Capture"
msgstr "Capturar"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Capture context, decisions, or @mention a teammate. No due date."
msgstr "Captura el contexto, decisiones, o menciona a un compañero. Sin fecha de vencimiento."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Card"
msgstr "Tarjeta"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Careers"
msgstr "Empleos"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Category"
msgstr "Categoría"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Category is locked for approved templates. Reject or pause it to change category."
msgstr "La categoría está bloqueada para plantillas aprobadas. Rechazala o pausala para cambiar la categoría."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/compose/template-body.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Change"
msgstr "Cambiar"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Change ▾"
msgstr "Cambiar ▾"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Change deal"
msgstr "Cambiar oportunidad"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
msgid "Change owners for {0}"
msgstr "Cambiar responsables para {0}"

#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#~ msgid "Change primary contact"
#~ msgstr "Cambiar contacto principal"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Changes don't shift this template into Marketing (different pricing tier)"
msgstr "Los cambios no mueven esta plantilla a Marketing (nivel de precios diferente)"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "channel"
msgstr "canal"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/types/v2/contact-filters.ts
msgid "Channel"
msgstr "Canal"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "channels"
msgstr "canales"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Channels"
msgstr "Canales"

#: app/frontend/lib/settings-nav.ts
msgid "Channels & AI"
msgstr "Canales e IA"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Charged today"
msgstr "Cobrado hoy"

#. placeholder {0}: item.ok ? "ok" : "not satisfied"
#. placeholder {1}: item.label
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Checklist item {0}: {1}"
msgstr "Elemento de la lista de verificación {0}: {1}"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Checkout cancelled — no charge was made."
msgstr "Compra cancelada — no se realizó ningún cargo."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Choose a follow-up template"
msgstr "Elige una plantilla de seguimiento"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Choose a source…"
msgstr "Elige una fuente…"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Choose a template"
msgstr "Elige una plantilla"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Choose call outcome"
msgstr "Elige el resultado de la llamada"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Choose header media file"
msgstr "Elige un archivo de encabezado"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Choose what this number can do."
msgstr "Elige qué puede hacer este número."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Choose your plan"
msgstr "Elige tu plan"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Churned"
msgstr "Cancelado"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Clear"
msgstr "Limpiar"

#. placeholder {0}: group.label
#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Clear {0} filter"
msgstr "Limpiar filtro de {0}"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Clear all"
msgstr "Limpiar todo"

#: app/frontend/components/v2/contacts/active-filter-chips.tsx
msgid "Clear filters"
msgstr "Limpiar filtros"

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Clear recipient"
msgstr "Limpiar destinatario"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Clear search"
msgstr "Limpiar búsqueda"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Close"
msgstr "Cerrar"

#. placeholder {0}: proposal.closeDate
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "close {0}"
msgstr "cerrar {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Close company drawer"
msgstr "Cerrar panel de empresa"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Close contact picker"
msgstr "Cerrar selector de contacto"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Close date"
msgstr "Fecha de cierre"

#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Close deal drawer"
msgstr "Cerrar panel de oportunidad"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Close drawer"
msgstr "Cerrar panel"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Close filter"
msgstr "Cerrar filtro"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Close picker"
msgstr "Cerrar selector"

#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Close search"
msgstr "Cerrar búsqueda"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
msgid "Close stage picker"
msgstr "Cerrar selector de etapa"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Close templates"
msgstr "Cerrar plantillas"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Closed · lost"
msgstr "Cerrado · perdido"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Closed · won"
msgstr "Cerrado · ganado"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Closed won"
msgstr "Cerrado ganado"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Closing this month"
msgstr "Cerrando este mes"

#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "Collapse sidebar"
msgstr "Contraer barra lateral"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Coming soon"
msgstr "Pronto"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Coming soon — this action will be wired in a follow-up."
msgstr "Pronto — esta acción se implementará en un seguimiento."

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Coming with AI"
msgstr "Próximamente con IA"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/page-shell.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Companies"
msgstr "Empresas"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Company"
msgstr "Empresa"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Company details"
msgstr "Detalles de la empresa"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Completed"
msgstr "Completado"

#: app/frontend/pages/v2/today/show.tsx
msgid "Completed today"
msgstr "Completado hoy"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Components"
msgstr "Componentes"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Conecto — back to top"
msgstr "Conecto — volver arriba"

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "Conecto captures every WhatsApp conversation in a beautifully simple CRM. Its AI drafts the replies, logs the deals, and lines up tomorrow's follow-ups — so nothing slips."
msgstr "Conecto captura cada conversación de WhatsApp en un CRM hermosamente simple. Su IA redacta las respuestas, registra las oportunidades y prepara los seguimientos de mañana, para que nada se escape."

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "Conecto handles every conversation across every channel. It works while you sleep, and asks for your call when it matters."
msgstr "Conecto maneja cada conversación en cada canal. Funciona mientras duermes y te llama cuando importa."

#: app/frontend/components/v2/landing/integrations.tsx
msgid "Conecto plugs into the tools your team already runs on — and keeps everything in sync, automatically."
msgstr "Conecto se conecta con las herramientas que tu equipo ya usa y mantiene todo sincronizado automáticamente."

#: app/frontend/types/v2/buy-number.ts
msgid "Confirm & pay"
msgstr "Confirmar y pagar"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Confirm 18% counter-offer details"
msgstr "Confirmar detalles de la contraoferta del 18%"

#: app/frontend/types/v2/buy-number.ts
msgid "Confirm and pay"
msgstr "Confirmar y pagar"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect"
msgstr "Conectar"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect another business number."
msgstr "Conecta otro número de negocio."

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect the places your customers already are. Your AI handles every channel from one inbox."
msgstr "Conecta los lugares donde tus clientes ya están. Tu IA maneja cada canal desde una sola inbox."

#: app/frontend/lib/settings-nav.ts
msgid "Connect the rest of your stack."
msgstr "Conecta el resto de tu stack."

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Connect WhatsApp and let the AI work your inbox tonight. You'll wake up to a queue that's ready."
msgstr "Conecta WhatsApp y deja que la IA trabaje tu inbox esta noche. Te despertarás con una cola lista."

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect WhatsApp first — it's the fastest way to give your AI something to do."
msgstr "Conecta WhatsApp primero — es la forma más rápida de darle algo a tu IA que hacer."

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-row.tsx
#: app/frontend/lib/voice-disposition.ts
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Connected"
msgstr "Conectado"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Connecting call"
msgstr "Conectando llamada"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/call-duration.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connecting…"
msgstr "Conectando…"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Connection error"
msgstr "Error de conexión"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/reassign-contact-assignees.tsx
#: app/frontend/components/v2/contacts/reassign-contact-assignees.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "contact"
msgstr "contacto"

#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Contact"
msgstr "Contacto"

#: app/frontend/lib/conversation-formatting.ts
msgid "Contact card"
msgstr "Tarjeta de contacto"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Contact created automatically"
msgstr "Contacto creado automáticamente"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Contact options"
msgstr "Opciones de contacto"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Contact sections"
msgstr "Secciones del contacto"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "contacts"
msgstr "contactos"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Contacts"
msgstr "Contactos"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "Continue"
msgstr "Continuar"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Continue with Apple"
msgstr "Continuar con Apple"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Continue with Google"
msgstr "Continuar con Google"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Conversation"
msgstr "Conversación"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Conversation actions"
msgstr "Acciones de conversación"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "conversations"
msgstr "conversaciones"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Conversations"
msgstr "Conversaciones"

#. placeholder {0}: conversations.length
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Conversations {0}"
msgstr "Conversaciones {0}"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Conversations and deals you're assigned to land here."
msgstr "Las conversaciones y oportunidades asignadas a ti aparecen aquí."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Conversations appear here when a contact reaches out on any connected channel."
msgstr "Las conversaciones aparecen aquí cuando un contacto se comunica por cualquier canal conectado."

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Conversations open"
msgstr "Conversaciones abiertas"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Copied"
msgstr "Copiado"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Copy code"
msgstr "Copiar código"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Copy code sample"
msgstr "Copiar muestra de código"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Copy number"
msgstr "Copiar número"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Copy share link"
msgstr "Copiar enlace de compartir"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Copy transcript"
msgstr "Copiar transcripción"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Couldn't connect"
msgstr "No se pudo conectar"

#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Couldn't delete — please try again."
msgstr "No se pudo eliminar — intenta de nuevo."

#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Couldn't load this preview. Try selecting it again."
msgstr "No se pudo cargar esta vista previa. Intenta seleccionarla de nuevo."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Couldn't save — please try again."
msgstr "No se pudo guardar — intenta de nuevo."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the date. Try again."
msgstr "No se pudo guardar la fecha. Intenta de nuevo."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the name. Try again."
msgstr "No se pudo guardar el nombre. Intenta de nuevo."

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Couldn't save the next step. Try again."
msgstr "No se pudo guardar el siguiente paso. Intenta de nuevo."

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Couldn't save the note. Try again."
msgstr "No se pudo guardar la nota. Intenta de nuevo."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the value. Try again."
msgstr "No se pudo guardar el valor. Intenta de nuevo."

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Couldn't save view — please try again."
msgstr "No se pudo guardar la vista — intenta de nuevo."

#: app/frontend/components/v2/contacts/contact-inline-edit-row.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
msgid "Couldn't save."
msgstr "No se pudo guardar."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Couldn't summarize this call"
msgstr "No se pudo resumir esta llamada"

#: app/frontend/types/v2/buy-number.ts
msgid "Country"
msgstr "País"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Country code"
msgstr "Código de país"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/lib/commands.ts
msgid "Create"
msgstr "Crear"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Create & link"
msgstr "Crear y vincular"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Create a template →"
msgstr "Crear una plantilla →"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Create account"
msgstr "Crear cuenta"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/lib/commands.ts
msgid "Create deal"
msgstr "Crear oportunidad"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Create new contact (coming soon)"
msgstr "Crear nuevo contacto (próximamente)"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Create new contact…"
msgstr "Crear nuevo contacto…"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Create opportunity"
msgstr "Crear oportunidad"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Create your first one from Settings."
msgstr "Crea el primero desde Ajustes."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Create your first template to start sending messages outside the 24-hour window."
msgstr "Crea tu primera plantilla para enviar mensajes fuera de la ventana de 24 horas."

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Create your workspace"
msgstr "Crea tu espacio de trabajo"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Created"
msgstr "Creado"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Creating…"
msgstr "Creando…"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Current"
#~ msgstr "Actual"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Current plan"
msgstr "Plan actual"

#. placeholder {0}: currentAssigneeLabel(conversation, t)
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Currently: {0}"
msgstr "Actualmente: {0}"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Custom"
msgstr "Personalizado"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Custom due date"
msgstr "Fecha de vencimiento personalizada"

#: app/frontend/lib/settings-nav.ts
msgid "Custom fields"
msgstr "Campos personalizados"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Customer"
msgstr "Cliente"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Customers"
msgstr "Clientes"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Customize"
msgstr "Personalizar"

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "Customize stages"
msgstr "Personalizar etapas"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Customize your pipeline"
msgstr "Personaliza tu embudo"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Daily spend"
msgstr "Gasto diario"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Danger zone"
msgstr "Zona de peligro"

#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "Dashboard"
msgstr "Panel"

#: app/frontend/pages/v2/today/show.tsx
msgid "day"
msgstr "día"

#: app/frontend/pages/v2/today/show.tsx
msgid "days"
msgstr "días"

#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Deal"
msgstr "Oportunidad"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Deal access"
msgstr "Acceso a oportunidades"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-trigger.tsx
#: app/frontend/components/v2/deals/deal-more-trigger.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Deal actions"
msgstr "Acciones de oportunidad"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal created"
msgstr "Oportunidad creada"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Deal details"
msgstr "Detalles de la oportunidad"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Deal linked"
msgstr "Oportunidad vinculada"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal name"
msgstr "Nombre de la oportunidad"

#: app/frontend/types/v2/contact-filters.ts
msgid "Deal stage"
msgstr "Etapa del negocio"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal value"
msgstr "Valor de la oportunidad"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-card.tsx
msgid "Deal: {0}"
msgstr "Oportunidad: {0}"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Deals"
msgstr "Oportunidades"

#. placeholder {0}: parts.join(" · ")
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "Deals · {0}"
msgstr "Oportunidades · {0}"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "Deals {summary}"
msgstr "Oportunidades {summary}"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Deals & pipeline"
msgstr "Oportunidades y embudo"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Deals move stages, values update, and health flags turn red on their own — read from the conversation, not typed into a form."
msgstr "Las oportunidades cambian de etapa, los valores se actualizan y los indicadores de salud se vuelven rojos automáticamente — extraídos de la conversación, no ingresados en un formulario."

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Deals owned"
msgstr "Oportunidades responsables"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Deals show up here as they move through this stage."
msgstr "Las oportunidades aparecen aquí a medida que avanzan en esta etapa."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "December"
msgstr "Diciembre"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Decline"
msgstr "Rechazar"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Decline call"
msgstr "Rechazar llamada"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Declined"
msgstr "Rechazado"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Default assignee"
msgstr "Responsable predeterminado"

#: app/frontend/components/v2/filters/saved-view-list.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete"
msgstr "Eliminar"

#. placeholder {0}: view.name
#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Delete \"{0}\"?"
msgstr "¿Eliminar \"{0}\"?"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete {templateName}?"
msgstr "¿Eliminar {templateName}?"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Delete deal"
msgstr "Eliminar oportunidad"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete template"
msgstr "Eliminar plantilla"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this deal?"
msgstr "¿Eliminar esta oportunidad?"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this follow-up?"
msgstr "¿Eliminar este seguimiento?"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Delete this note"
msgstr "Eliminar esta nota"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this note?"
msgstr "¿Eliminar esta nota?"

#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Deleting…"
msgstr "Eliminando…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delivered"
msgstr "Entregado"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Description (helper text — shown on the template detail)"
msgstr "Descripción (texto de ayuda — mostrado en el detalle de la plantilla)"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Description for variable {n}"
msgstr "Descripción para la variable {n}"

#. placeholder {0}: item.title
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Deselect {0}"
msgstr "Deseleccionar {0}"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Desktop dock"
msgstr "Dock de escritorio"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Destructive actions for {0}."
msgstr "Acciones destructivas para {0}."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Determines pricing and Meta's review rules. Pick the one that matches your intent."
msgstr "Determina los precios y las reglas de revisión de Meta. Elige la que coincida con tu intención."

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial {tone}"
msgstr "Marcar {tone}"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial pad"
msgstr "Teclado numérico"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial pound"
msgstr "Marcar numeral"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial star"
msgstr "Marcar asterisco"

#: app/frontend/components/v2/settings/team/team-voice-switch.tsx
msgid "Disable voice for teammate {employeeId}"
msgstr "Desactivar voz para el compañero de equipo {employeeId}"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Disconnect"
msgstr "Desconectar"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Disconnect WhatsApp number"
msgstr "Desconectar número de WhatsApp"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Disconnected"
msgstr "Desconectado"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Dismiss"
msgstr "Descartar"

#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Dismiss suggestion"
msgstr "Descartar sugerencia"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Display name"
msgstr "Nombre mostrado"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Do it"
msgstr "Hazlo"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Do not disturb"
msgstr "No molestar"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Document"
msgstr "Documento"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Document up to 100 MB · the sample Meta reviews"
msgstr "Documento hasta 100 MB · la muestra que Meta revisa"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Don't link a deal"
msgstr "No vincular una oportunidad"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Done"
msgstr "Listo"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Download"
msgstr "Descargar"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Draft"
msgstr "Borrador"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Draft save status"
msgstr "Estado de guardado del borrador"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Drag a file here, or <0>browse</0>"
msgstr "Arrastra un archivo aquí o <0>explora</0>"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Drag to reorder"
msgstr "Arrastra para reordenar"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Drawer details"
msgstr "Detalles del panel lateral"

#: app/frontend/components/v2/deals/deal-column.tsx
msgid "Drop"
msgstr "Suelta"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Drop a chat bubble on your site. AI greets and qualifies visitors."
msgstr "Coloca una burbuja de chat en tu sitio. La IA saluda y califica visitantes."

#. placeholder {0}: stage.name
#: app/frontend/components/v2/deals/deal-column.tsx
msgid "Drop here to move to {0}"
msgstr "Suelta aquí para mover a {0}"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "DUE"
#~ msgstr ""

#. placeholder {0}: formatDueAt(dueAt)
#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Due {0}"
msgstr "Vence {0}"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Due date"
msgstr "Fecha de vencimiento"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Duplicate"
msgstr "Duplicar"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Duplicate deal"
msgstr "Duplicar oportunidad"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "e.g. {firstName} — annual renewal"
msgstr "p. ej. {firstName} — renovación anual"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "e.g. Acme · annual renewal"
msgstr "p. ej. Acme · renovación anual"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. customer_name"
msgstr "p. ej. customer_name"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "e.g. deal_followup_v3"
msgstr "p. ej. deal_followup_v3"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. Order update"
msgstr "p. ej. Actualización de pedido"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. Reply STOP to opt out"
msgstr "p. ej. Responde STOP para dejar de recibir"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Earlier"
msgstr "Antes"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Earlier this week"
msgstr "Antes esta semana"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Edit"
msgstr "Editar"

#. placeholder {0}: label.toLowerCase()
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
msgid "Edit {0}"
msgstr "Editar {0}"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Edit AI summary"
msgstr "Editar resumen de IA"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Edit capabilities"
msgstr "Editar capacidades"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit close date"
msgstr "Editar fecha de cierre"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit deal name"
msgstr "Editar nombre de oportunidad"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit deal value"
msgstr "Editar valor de oportunidad"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Edit due date"
msgstr "Editar fecha de vencimiento"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Edit first"
msgstr "Edita primero"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Edit message"
msgstr "Editar mensaje"

#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
msgid "Edit next step"
msgstr "Editar siguiente paso"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Edit next step title"
msgstr "Editar título del siguiente paso"

#. placeholder {0}: member.name
#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Edit numbers that ring {0}"
msgstr "Editar números que suenan en {0}"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit owners"
msgstr "Editar responsables"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Edit quota exhausted"
msgstr "Cuota de edición agotada"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Edit quota exhausted — try again next window"
msgstr "Cuota de edición agotada — intenta de nuevo en la siguiente ventana"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#~ msgid "Edit step"
#~ msgstr ""

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Edit template"
msgstr "Editar plantilla"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Edit value"
msgstr "Editar valor"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Editing this template will resubmit it to Meta for review. Only category and components can be changed — name and language are locked."
msgstr "Editar esta plantilla la reenviará a Meta para revisión. Solo se puede cambiar la categoría y los componentes — el nombre e idioma están bloqueados."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Editing will resubmit this template to Meta"
msgstr "Editar reenviará esta plantilla a Meta"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Email"
msgstr "Correo"

#. placeholder {0}: contact.email
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Email {0}"
msgstr "Correo {0}"

#: app/frontend/components/v2/settings/team/team-voice-switch.tsx
msgid "Enable voice for teammate {employeeId}"
msgstr "Habilitar voz para el compañero {employeeId}"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "End"
msgstr "Fin"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "End of month"
msgstr "Fin de mes"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "End of quarter"
msgstr "Fin de trimestre"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "English (US)"
msgstr "Inglés (EE.UU.)"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Estimated monthly cost"
msgstr "Costo mensual estimado"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Every company is enriched."
msgstr "Todas las empresas están enriquecidas."

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Every lead captured at the speed of a text"
msgstr "Cada prospecto capturado a la velocidad de un mensaje"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Every number is already on this teammate."
msgstr "Cada número ya está asignado a este compañero."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Every variable has a source and sample value"
msgstr "Cada variable tiene una fuente y valor de muestra"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Everyone on the workspace has access."
msgstr "Todos en el espacio de trabajo tienen acceso."

#: app/frontend/components/v2/inbox/rail.tsx
msgid "Expand sidebar"
msgstr "Expandir barra lateral"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Expected close date"
msgstr "Fecha estimada de cierre"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Failed"
msgstr "Falló"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Features"
msgstr "Características"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "February"
msgstr "Febrero"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Feeds the AI summary when the call ends."
msgstr "Alimenta el resumen de IA cuando termina la llamada."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "File"
msgstr "Archivo"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Files"
msgstr "Archivos"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Files shared in conversations will show up here."
msgstr "Los archivos compartidos en conversaciones aparecerán aquí."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Fill in variables"
msgstr "Rellena variables"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Fill variable {token}"
msgstr "Rellena variable {token}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "filter"
msgstr "filtrar"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Filter"
msgstr "Filtrar"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Filter ({activeMobileFilterCount} active)"
msgstr "Filtrar ({activeMobileFilterCount} activos)"

#. placeholder {0}: group.label
#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Filter by {0}"
msgstr "Filtrar por {0}"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Filter by title…"
msgstr "Filtrar por título…"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Filter captures"
msgstr "Filtrar capturas"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Filter contacts"
msgstr "Filtrar contactos"

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Filter contacts ({activeFilterCount} active)"
msgstr "Filtrar contactos ({activeFilterCount} activos)"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter date"
msgstr "Filtrar fecha"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter deals"
msgstr "Filtrar oportunidades"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter field"
msgstr "Filtrar campo"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Filter inbox"
msgstr "Filtrar inbox"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Filter notifications"
msgstr "Filtrar notificaciones"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter operator"
msgstr "Operador de filtro"

#: app/frontend/components/v2/search/search-tabs.tsx
msgid "Filter results by type"
msgstr "Filtrar resultados por tipo"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Filter templates by status"
msgstr "Filtrar plantillas por estado"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals closing this month"
msgstr "Filtrar oportunidades que cierran este mes"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals that need you (coming with AI)"
msgstr "Filtrar oportunidades que te necesitan (viene con IA)"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals with no next step"
msgstr "Filtrar oportunidades sin siguiente paso"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to my deals"
msgstr "Filtrar mis oportunidades"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter value"
msgstr "Valor de filtro"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter values"
msgstr "Valores de filtro"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "filters"
msgstr "filtros"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Find any deal, contact, company, conversation, or note. Type > to run a command instead."
msgstr "Busca cualquier oportunidad, contacto, empresa, conversación o nota. Escribe > para ejecutar un comando en su lugar."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "First-touch must use an approved template"
msgstr "El primer contacto debe usar una plantilla aprobada"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up"
msgstr "Seguimiento"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up actions"
msgstr "Acciones de seguimiento"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Follow-up deleted"
msgstr "Seguimiento eliminado"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up scheduled"
msgstr "Seguimiento programado"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Follow-up sent"
msgstr "Seguimiento enviado"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-ups"
msgstr "Seguimientos"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Footer"
msgstr "Pie de página"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Footer text"
msgstr "Texto del pie de página"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "for {firstName}"
msgstr "para {firstName}"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Forgot?"
msgstr "¿Olvidaste?"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Forward emails into the inbox so AI replies in your tone."
msgstr "Reenvía correos al inbox para que la IA responda con tu tono."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Fr"
msgstr "Vi"

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Free 14-day trial · no credit card · cancel anytime"
msgstr "Prueba gratuita de 14 días · sin tarjeta de crédito · cancela cuando quieras"

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "Free 14-day trial · no credit card required"
msgstr "Prueba gratuita de 14 días · sin tarjeta de crédito requerida"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "French (France)"
msgstr "Francés (Francia)"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Friday, May 31"
msgstr "Viernes, 31 de mayo"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "From "
msgstr "De "

#. placeholder {0}: pricing.baseFromLabel
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "from {0}"
msgstr "de {0}"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "from your call"
msgstr "de tu llamada"

#. placeholder {0}: row.fromCallLabel
#. placeholder {0}: step.fromCallLabel
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "from your call {0}"
msgstr "de tu llamada {0}"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/today/from-call-breadcrumb.tsx
msgid "from your call {label}"
msgstr "de tu llamada {label}"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/pages/v2/registrations/new.tsx
msgid "Full name"
msgstr "Nombre completo"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Get started"
msgstr "Comienza"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#~ msgid "Gift"
#~ msgstr ""

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Give the next step a title."
msgstr "Dale un título al siguiente paso."

#: app/frontend/lib/commands.ts
msgid "Go to Deals"
msgstr "Ir a oportunidades"

#: app/frontend/lib/commands.ts
msgid "Go to Inbox"
msgstr "Ir al inbox"

#: app/frontend/lib/commands.ts
msgid "Go to Settings › Channels"
msgstr "Ir a ajustes › canales"

#: app/frontend/lib/commands.ts
msgid "Go to Settings › Templates"
msgstr "Ir a ajustes › plantillas"

#: app/frontend/lib/commands.ts
msgid "Go to Today"
msgstr "Ir a hoy"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Google sign-in is coming soon"
msgstr "El inicio de sesión con Google vendrá pronto"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Hand off to a teammate when the conversation needs a human."
msgstr "Pasa la conversación a un compañero cuando necesite un humano."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Handled by AI"
msgstr "Manejado por IA"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hang up"
msgstr "Colgar"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Header"
msgstr "Encabezado"

#. placeholder {0}: i18n._(seg.label)
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header {0}"
msgstr "Encabezado {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header media format"
msgstr "Formato de media del encabezado"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header text"
msgstr "Texto del encabezado"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header type"
msgstr "Tipo de encabezado"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header variable — Meta needs a sample value"
msgstr "Variable del encabezado — Meta necesita un valor de ejemplo"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header variable sample"
msgstr "Ejemplo de variable del encabezado"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Heads-up on conversations, deals, and AI handoffs lands here."
msgstr "Las notificaciones sobre conversaciones, oportunidades y entregas de IA llegan aquí."

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Help & support"
msgstr "Ayuda y soporte"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Help center"
msgstr "Centro de ayuda"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Hi {{1}}, your order is on its way."
msgstr "Hola {{1}}, tu pedido está en camino."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Hide"
msgstr "Ocultar"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hide dial pad"
msgstr "Ocultar teclado"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Hide dismissed"
msgstr "Ocultar descartados"

#. placeholder {0}: firstName(conversation)
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Hide from inbox until {0} replies, the time below, or anything new comes in — whichever first."
msgstr "Oculta del inbox hasta que {0} responda, la hora siguiente, o lllegue algo nuevo — lo que sea primero."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hide note"
msgstr "Ocultar nota"

#: app/frontend/components/v2/auth/auth-text-field.tsx
msgid "Hide password"
msgstr "Ocultar contraseña"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/deal-entry-body.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "History"
msgstr "Historial"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Hold AI replies for review before they go out."
msgstr "Retén respuestas de IA para revisión antes de que salgan."

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Hold to record"
msgstr "Mantén para grabar"

#: app/frontend/components/v2/settings/usage/how-billing-works.tsx
msgid "How billing works"
msgstr "Cómo funciona la facturación"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "https://linkedin.com/in/…"
msgstr "https://linkedin.com/in/…"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Identity"
msgstr "Identidad"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Image"
msgstr "Imagen"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Image up to 5 MB · the sample Meta reviews"
msgstr "Imagen hasta 5 MB · el ejemplo que Meta revisa"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Import"
msgstr "Importar"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "In 1 week"
msgstr "En 1 semana"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/people-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "In active deal"
msgstr "En oportunidad activa"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "In progress"
msgstr "En progreso"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "in the past"
msgstr "en el pasado"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Inbox"
msgstr "Inbox"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Inbox access"
msgstr "Acceso al inbox"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "Inbox filters"
msgstr "Filtros del inbox"

#: app/frontend/pages/v2/today/show.tsx
msgid "Inbox zero"
msgstr "Inbox cero"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "included"
msgstr "incluido"

#: app/frontend/components/v2/settings/phone-numbers/buy/capability-toggle-row.tsx
msgid "Included"
msgstr "Incluido"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "Included with your plan"
msgstr "Incluido con tu plan"

#: app/frontend/components/v2/voice/call-row.tsx
#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Incoming call"
msgstr "Llamada entrante"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Incoming message"
msgstr "Mensaje entrante"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Industry"
msgstr "Industria"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Insert emoji"
msgstr "Insertar emoji"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Insert image"
msgstr "Insertar imagen"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Insert variable"
msgstr "Insertar variable"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Instagram DM"
msgstr "Instagram DM"

#: app/frontend/lib/settings-nav.ts
msgid "Integrations"
msgstr "Integraciones"

#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite teammate"
msgstr "Invitar compañero"

#: app/frontend/lib/settings-nav.ts
msgid "Invite teammates and set roles."
msgstr "Invita compañeros y asigna roles."

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite teammates is coming soon."
msgstr "Invitar compañeros vendrá pronto."

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite your first teammate to start sharing the inbox."
msgstr "Invita tu primer compañero para empezar a compartir el inbox."

#: app/frontend/types/v2/contact-filters.ts
msgid "is"
msgstr "es"

#: app/frontend/types/v2/deal-filters.ts
msgid "is after"
msgstr "es después de"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is any of"
msgstr "es alguno de"

#: app/frontend/types/v2/deal-filters.ts
msgid "is at least"
msgstr "es al menos"

#: app/frontend/types/v2/deal-filters.ts
msgid "is at most"
msgstr "es como máximo"

#: app/frontend/types/v2/deal-filters.ts
msgid "is before"
msgstr "es antes de"

#: app/frontend/types/v2/deal-filters.ts
msgid "is between"
msgstr "está entre"

#: app/frontend/types/v2/deal-filters.ts
msgid "is in"
msgstr "está en"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is not"
msgstr "no es"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is stale"
msgstr "está inactivo"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is unassigned"
msgstr "no está asignado"

#: app/frontend/pages/v2/deals/show.tsx
msgid "It may have been deleted, or it belongs to a different workspace. Head back to your deals to see what's open."
msgstr "Pudo haber sido eliminado, o pertenece a un espacio de trabajo diferente. Vuelve a tus oportunidades para ver qué está abierto."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "It's been over 24h since {firstName} last messaged. Only an approved template can send."
msgstr "Ha pasado más de 24h desde que {firstName} escribió. Solo una plantilla aprobada puede enviar."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "It's been over 24h, so WhatsApp only allows an approved template — and you don't have one set up. Here's what works instead:"
msgstr "Ha pasado más de 24h, así que WhatsApp solo permite una plantilla aprobada — y no tienes una configurada. Aquí hay qué funciona en su lugar:"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Italic"
msgstr "Cursiva"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "January"
msgstr "Enero"

#. placeholder {0}: employee.createdAtLabel
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Joined {0}"
msgstr "Se unió {0}"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Jot something for the summary…"
msgstr "Escribe algo para el resumen…"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "JPG, PNG, GIF · up to 5 MB"
msgstr "JPG, PNG, GIF · hasta 5 MB"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "July"
msgstr "Julio"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "June"
msgstr "Junio"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "just now"
msgstr "justo ahora"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Keep separate"
msgstr "Mantener separado"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Keep this deal"
msgstr "Mantener esta oportunidad"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Keypad"
msgstr "Teclado"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "KIND"
#~ msgstr ""

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Language"
msgstr "Idioma"

#: app/frontend/lib/usage-props.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Last 30 days"
msgstr "Últimos 30 días"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Last activity"
msgstr "Última actividad"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Last sign-in"
msgstr "Último inicio de sesión"

#. placeholder {0}: relativeTimeLabel(lastSyncedAt, now)
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Last synced {0}"
msgstr "Última sincronización {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Last touch"
msgstr "Último contacto"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Last used"
msgstr "Usado por última vez"

#: app/frontend/pages/v2/today/show.tsx
msgid "Later this week"
msgstr "Más adelante esta semana"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Left voicemail"
msgstr "Dejó buzón de voz"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Link a deal"
msgstr "Vincular una oportunidad"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Link sample · e.g. https://example.com/order/1234"
msgstr "Ejemplo de enlace · ej. https://example.com/order/1234"

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Link to an opportunity"
msgstr "Vincular a una oportunidad"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Linked deal"
msgstr "Oportunidad vinculada"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Linked deal stage"
msgstr "Etapa de oportunidad vinculada"

#. placeholder {0}: dealSubtitle(deal)
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Linked now · {0}"
msgstr "Vinculado ahora · {0}"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "Linked opportunities"
msgstr "Oportunidades vinculadas"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "Linked opportunity"
msgstr "Oportunidad vinculada"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Linked to {0}"
msgstr "Vinculado a {0}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Linked to a deal"
msgstr "Vinculado a una oportunidad"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "LinkedIn"
msgstr "LinkedIn"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Live"
msgstr "En vivo"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Live chat"
msgstr "Chat en vivo"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Live chat widget"
msgstr "Widget de chat en vivo"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Live preview"
msgstr "Vista previa en vivo"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Loading company…"
msgstr "Cargando empresa…"

#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Loading deal…"
msgstr "Cargando oportunidad…"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Loading deals…"
msgstr "Cargando oportunidades…"

#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "Loading older messages"
msgstr "Cargando mensajes anteriores"

#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Loading preview…"
msgstr "Cargando vista previa…"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Loading regions…"
msgstr "Cargando regiones…"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Loading teammates…"
msgstr "Cargando compañeros…"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Loading the follow-up…"
msgstr "Cargando el seguimiento…"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Loading…"
msgstr "Cargando…"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Local number (most countries)"
msgstr "Número local (la mayoría de países)"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Location"
msgstr "Ubicación"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Location pin"
msgstr "Marcador de ubicación"

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Log out"
msgstr "Cerrar sesión"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Log this call against a deal — follow-ups move with it."
msgstr "Registra esta llamada en una oportunidad — los seguimientos se mueven con ella."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Logged"
msgstr "Registrado"

#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Loosen the filters above to see more."
msgstr "Relaja los filtros arriba para ver más."

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Lost"
msgstr "Perdida"

#: app/frontend/components/v2/landing/testimonials.tsx
msgid "Loved by closers"
msgstr "Amado por los vendedores"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Lowercase, numbers, and underscores only. Internal — recipients don't see this."
msgstr "Solo minúsculas, números y guiones bajos. Interno — los destinatarios no ven esto."

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Make primary"
msgstr "Hacer principal"

#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Manage"
msgstr "Gestionar"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Manage billing"
msgstr "Gestionar facturación"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Manage contacts"
msgstr "Administrar contactos"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Manage templates"
msgstr "Gestionar plantillas"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Manage templates →"
msgstr "Gestionar plantillas →"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Manage your plan, seats, and payment method."
msgstr "Gestiona tu plan, asientos y método de pago."

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Manager"
msgstr "Gestor"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Map each placeholder to a default source. Meta requires a sample value for review."
msgstr "Asigna cada marcador de posición a una fuente predeterminada. Meta requiere un valor de ejemplo para la revisión."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "March"
msgstr "Marzo"

#. placeholder {0}: step.title ?? t`next step`
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Mark {0} complete"
msgstr "Marcar {0} como completado"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Mark all read"
msgstr "Marcar todo como leído"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Mark as lost"
msgstr "Marcar como perdida"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Mark as not done"
msgstr "Marcar como no completado"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Mark as resolved"
msgstr "Marcar como resuelto"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Mark as won"
msgstr "Marcar como ganada"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Mark complete"
msgstr "Marcar como completado"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Marketing"
msgstr "Marketing"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Maximum value"
msgstr "Valor máximo"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "May"
msgstr "Mayo"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Maybe later"
msgstr "Quizás más tarde"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/pages/v2/deals/show.tsx
msgid "Me"
msgstr "Yo"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "Me — {0}"
#~ msgstr ""

#. placeholder {0}: option.name
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Me · {0}"
msgstr "Yo · {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Media"
msgstr "Multimedia"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Median response"
msgstr "Respuesta mediana"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Members"
msgstr "Miembros"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Mention someone"
msgstr "Menciona a alguien"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Mention suggestions"
msgstr "Sugerencias de mención"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Mentions"
msgstr "Menciones"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "message"
msgstr "mensaje"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/lib/conversation-formatting.ts
msgid "Message"
msgstr "Mensaje"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Message on WhatsApp"
msgstr "Mensaje en WhatsApp"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "messages"
msgstr "mensajes"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Messages"
msgstr "Mensajes"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "messages this month"
msgstr "mensajes este mes"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Messages this month"
msgstr "Mensajes este mes"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta details"
msgstr "Detalles de Meta"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Meta is running an experiment on this recipient that temporarily caps sends. Try again later, or reach out another way in the meantime."
msgstr "Meta está ejecutando un experimento en este destinatario que limita temporalmente los envíos. Intenta más tarde o comunícate de otra forma mientras tanto."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta rejected this template"
msgstr "Meta rechazó esta plantilla"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta removes it once any in-flight messages settle. You can't reuse this name for 30 days after deletion."
msgstr "Meta la elimina una vez que los mensajes en tránsito se resuelvan. No puedes reutilizar este nombre durante 30 días después de la eliminación."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Meta usually approves templates in under 30 minutes, but it can take up to 24h. You'll get a notification when it's ready to send."
msgstr "Meta generalmente aprueba plantillas en menos de 30 minutos, pero puede tomar hasta 24h. Recibirás una notificación cuando esté lista para enviar."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Meta usually re-approves edits in under 30 minutes. Sends pause until approval lands."
msgstr "Meta generalmente re-aprueba ediciones en menos de 30 minutos. Los envíos se pausan hasta que la aprobación se registre."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta-approved category"
msgstr "Categoría aprobada por Meta"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Meta's algorithm blocked this delivery to protect message quality on this number. Try a different template, wait a bit, or reach out another way — repeated sends in the same template can make this worse."
msgstr "El algoritmo de Meta bloqueó este envío para proteger la calidad de los mensajes en este número. Intenta una plantilla diferente, espera un poco o comunícate de otra forma — los envíos repetidos en la misma plantilla pueden empeorar esto."

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Method"
msgstr "Método"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "METHOD"
#~ msgstr ""

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Microphone"
msgstr "Micrófono"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Microphones will appear once voice connects."
msgstr "Los micrófonos aparecerán una vez que se conecte la voz."

#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/today/mobile-tabs.tsx
msgid "Mine"
msgstr "Mío"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Minimum value"
msgstr "Valor mínimo"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Minutes"
msgstr "Minutos"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Missed"
msgstr "Perdida"

#: app/frontend/pages/v2/companies/index.tsx
msgid "missing data"
msgstr "datos faltantes"

#: app/frontend/pages/v2/companies/index.tsx
msgid "missing industry or size"
msgstr "industria o tamaño faltante"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Mo"
msgstr "Lu"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Mobile sheet"
msgstr "Hoja móvil"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
msgid "Monthly"
msgstr "Mensual"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Monthly cost"
msgstr "Costo mensual"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "More"
msgstr "Más"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "More actions"
msgstr "Más acciones"

#: app/frontend/components/v2/today/activity-row.tsx
#~ msgid "More options"
#~ msgstr ""

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Most popular"
msgstr "Más popular"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Most recent"
msgstr "Más reciente"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Move deal to the next stage"
msgstr "Mover oportunidad a la siguiente etapa"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Move to another deal"
msgstr "Mover a otra oportunidad"

#. placeholder {0}: row.dealName
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Move to another deal — currently {0}"
msgstr "Mover a otra oportunidad — actualmente {0}"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Move to another deal — currently {label}"
msgstr "Mover a otra oportunidad — actualmente {label}"

#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "Move to deal"
msgstr "Mover a oportunidad"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/stage-picker.tsx
#: app/frontend/components/v2/deals/stage-picker.tsx
msgid "Move to stage"
msgstr "Mover a etapa"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Mute"
msgstr "Silenciar"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Mute notifications"
msgstr "Silenciar notificaciones"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Muted"
msgstr "Silenciado"

#: app/frontend/pages/v2/today/show.tsx
msgid "My activities"
msgstr "Mis actividades"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/lib/activity-facets.ts
msgid "Name"
msgstr "Nombre"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Name and language are locked once a template is approved by Meta."
msgstr "El nombre e idioma se bloquean una vez que Meta aprueba la plantilla."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name and language stay the same after submission — choose carefully."
msgstr "El nombre e idioma se mantienen igual después del envío — elige con cuidado."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Name and language stay unchanged — you can't edit those for an approved template"
msgstr "El nombre e idioma se mantienen sin cambios — no puedes editar esos en una plantilla aprobada"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Name can't be blank."
msgstr "El nombre no puede estar vacío."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name character count"
msgstr "Conteo de caracteres del nombre"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Name for variable {n}"
msgstr "Nombre para la variable {n}"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Name this view"
msgstr "Nombra esta vista"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name uses only lowercase letters, numbers, and underscores"
msgstr "El nombre solo usa letras minúsculas, números e guiones bajos"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "name@example.com"
msgstr "name@example.com"

#: app/frontend/components/v2/search/palette-footer.tsx
#: app/frontend/lib/commands.ts
msgid "Navigate"
msgstr "Navegar"

#: app/frontend/components/v2/chrome/mobile-nav-drawer.tsx
msgid "Navigation"
msgstr "Navegación"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Needs enrichment"
msgstr "Necesita enriquecimiento"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Needs reply"
msgstr "Necesita respuesta"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Needs you"
msgstr "Te necesita"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Negative"
msgstr "Negativo"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Neutral"
msgstr "Neutral"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "Never contacted"
msgstr "Nunca contactado"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Never sent"
msgstr "Nunca enviado"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Never synced"
msgstr "Nunca sincronizado"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "New"
msgstr "Nuevo"

#: app/frontend/components/v2/companies/index-header.tsx
msgid "New company"
msgstr "Nueva empresa"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "New contact"
msgstr "Nuevo contacto"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "New conversation"
msgstr "Nueva conversación"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "New conversations on this channel are assigned to this teammate by default."
msgstr "Las nuevas conversaciones en este canal se asignan a este compañero por defecto."

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "New deal"
msgstr "Nueva oportunidad"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "New deal for {firstName}"
msgstr "Nueva oportunidad para {firstName}"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "New follow-up"
msgstr "Nuevo seguimiento"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "new line"
msgstr "nueva línea"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "New note"
msgstr "Nueva nota"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "New notifications will show up here."
msgstr "Las nuevas notificaciones aparecerán aquí."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "New opportunity"
msgstr "Nueva oportunidad"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "New template"
msgstr "Nueva plantilla"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "New WhatsApp message"
msgstr "Nuevo mensaje de WhatsApp"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Next edit available in ~{hrs}h"
msgstr "Siguiente edición disponible en ~{hrs}h"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Next month"
msgstr "Mes próximo"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "next step"
msgstr "siguiente paso"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Next step"
msgstr "Siguiente paso"

#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "Next step added"
msgstr "Siguiente paso agregado"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Next step options"
msgstr "Opciones de siguiente paso"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Next step title"
msgstr "Título del siguiente paso"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Next steps"
msgstr "Siguientes pasos"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Next week"
msgstr "Próxima semana"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "No account?"
msgstr "¿Sin cuenta?"

#: app/frontend/pages/v2/today/show.tsx
msgid "No activities for tomorrow yet."
msgstr "Sin actividades para mañana aún."

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No activity yet for this company."
msgstr "Sin actividad aún para esta empresa."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "No answer"
msgstr "Sin respuesta"

#: app/frontend/lib/voice-disposition.ts
msgid "No answer — line rang out"
msgstr "Sin respuesta — la línea sonó"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "No answer · rang {ringSeconds}s"
msgstr "Sin respuesta · sonó {ringSeconds}s"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "No approved templates in this category yet."
msgstr "Sin plantillas aprobadas en esta categoría aún."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "No approved templates yet"
msgstr "Sin plantillas aprobadas aún"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No approved templates yet."
msgstr "Sin plantillas aprobadas aún."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "No calls, notifications muted"
msgstr "Sin llamadas, notificaciones silenciadas"

#: app/frontend/components/v2/search/command-list.tsx
msgid "No command matches \"{filter}\""
msgstr "Ningún comando coincide con \"{filter}\""

#: app/frontend/pages/v2/companies/index.tsx
msgid "No companies match"
msgstr "Ninguna empresa coincide"

#: app/frontend/pages/v2/companies/index.tsx
msgid "No companies yet"
msgstr "Sin empresas aún"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/people-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No contacts linked to this company yet."
msgstr "Sin contactos vinculados a esta empresa aún."

#: app/frontend/pages/v2/contacts/index.tsx
msgid "No contacts match"
msgstr "Ningún contacto coincide"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "No contacts yet"
msgstr "Sin contactos aún"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "No conversations match \"{query}\""
msgstr "Ninguna conversación coincide con \"{query}\""

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No conversations yet."
msgstr "Sin conversaciones aún."

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "No countries match \"{0}\". Try another search."
msgstr "Ningún país coincide con \"{0}\". Intenta otra búsqueda."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "No deal"
msgstr "Sin oportunidad"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "No deal — just the contact"
msgstr "Sin oportunidad — solo el contacto"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "No deal stages yet. Add a pipeline to filter by stage."
msgstr "Sin etapas de oportunidad aún. Agrega un embudo para filtrar por etapa."

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "No deal yet"
msgstr "Sin oportunidad aún"

#. placeholder {0}: voiceCall.contact?.name ?? t`this contact`
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "No deals linked to <0>{0}</0> yet. Create one to attach this call."
msgstr "Sin oportunidades vinculadas a <0>{0}</0> aún. Crea una para adjuntar esta llamada."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No deals match \"{search}\"."
msgstr "Ninguna oportunidad coincide con \"{search}\"."

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No deals tracked for this contact yet."
msgstr "Sin oportunidades rastreadas para este contacto aún."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No deals with {firstName} yet"
msgstr "Sin oportunidades con {firstName} aún"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/deals-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No deals yet at this company."
msgstr "Sin oportunidades aún en esta empresa."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "No default assignee"
msgstr "Sin responsable por defecto"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No files yet"
msgstr "Sin archivos aún"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No follow-ups yet."
msgstr "Sin seguimientos aún."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No follow-ups yet. Add one to keep things moving."
msgstr "Sin seguimientos aún. Agrega uno para mantener las cosas en movimiento."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "No linked deal"
msgstr "Sin oportunidad vinculada"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "No matches. Try a different name, email, or phone."
msgstr "Sin coincidencias. Intenta un nombre, correo o teléfono diferente."

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "No matches. Try a different name."
msgstr "Sin coincidencias. Intenta un nombre diferente."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "No matching contact"
msgstr "Ningún contacto coincide"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "No mentions yet."
msgstr "Sin menciones aún."

#: app/frontend/components/v2/inbox/conversation-row.tsx
#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "No messages yet"
msgstr "Sin mensajes aún"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "No microphone detected. Connect one and allow mic access to choose it here."
msgstr "Ningún micrófono detectado. Conecta uno y permite acceso al micrófono para seleccionarlo aquí."

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "No more deciding where to start. The AI lines up exactly who to follow up with, and why — you just work the queue."
msgstr "Sin más decidir por dónde empezar. La IA alinea exactamente a quién hacer seguimiento y por qué — solo trabajas la cola."

#. placeholder {0}: contact.addedAgo
#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "No name yet · {0}"
msgstr "Sin nombre aún · {0}"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "No next step"
msgstr "Sin siguiente paso"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "No next steps yet. Add one to track what comes next on this deal."
msgstr "Sin siguientes pasos aún. Agrega uno para rastrear qué sigue en esta oportunidad."

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "No notifications yet."
msgstr "Sin notificaciones aún."

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "No numbers match"
msgstr "Ningún número coincide"

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "No numbers match \"{0}\"."
msgstr "Ningún número coincide con \"{0}\"."

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "No numbers yet"
msgstr "Sin números aún"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "No numbers yet. Buy one from the Phone numbers settings."
msgstr "Sin números aún. Compra uno en los ajustes de Números telefónicos."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "No open deals for this contact yet."
msgstr "Sin oportunidades abiertas para este contacto aún."

#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "No options available"
msgstr "Sin opciones disponibles"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "No other contact details on file yet. Add a phone or email on the contact card to reach out elsewhere."
msgstr "Sin otros detalles de contacto registrados aún. Agrega un teléfono o correo en la tarjeta de contacto para contactar en otro lugar."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No other deals to move this to yet."
msgstr "Sin otras oportunidades para mover esto aún."

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "No other open opportunities to link."
msgstr "No hay otras oportunidades abiertas para vincular."

#: app/frontend/components/v2/contacts/row-actions.tsx
msgid "No phone number on file"
msgstr "Sin número de teléfono registrado"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "No phone numbers yet"
msgstr "Sin números de teléfono aún"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No pipeline available"
msgstr "Sin embudo disponible"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "No pipeline set up yet."
msgstr "Sin embudo configurado aún."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "No preview call available — run <0>db:seed</0> in the agent."
msgstr "Sin llamada de vista previa disponible — ejecuta <0>db:seed</0> en el agente."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No problem — this call's follow-ups track on {firstName}'s contact. Link a deal anytime later."
msgstr "Sin problema — los seguimientos de esta llamada se rastrean en el contacto de {firstName}. Vincula una oportunidad cuando quieras."

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "No quick replies yet. Create your first one from Settings."
msgstr "Sin respuestas rápidas aún. Crea la primera desde ajustes."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "No regions match. Try another search."
msgstr "Ninguna región coincide. Intenta otra búsqueda."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "No sends yet"
msgstr "Sin envíos aún"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "No shortcuts match “{query}”."
msgstr "Ningún atajo coincide con “{query}”."

#: app/frontend/components/v2/voice/transcript-turns.tsx
msgid "No speech was captured on this call."
msgstr "No se capturó voz en esta llamada."

#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "No stages yet."
msgstr "Sin etapas aún."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "No suggestion"
msgstr "Sin sugerencia"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "No tags yet."
msgstr "Sin etiquetas aún."

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "No teammates match"
msgstr "Ningún compañero coincide"

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "No teammates match \"{0}\"."
msgstr "Ningún compañero coincide con \"{0}\"."

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "No teammates match \"{query}\"."
msgstr "Ningún compañero coincide con \"{query}\"."

#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "No teammates match “{query}”."
msgstr "Ningún compañero coincide con “{query}”."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template (let AI pick the best match)"
msgstr "Sin plantilla (dejar que la IA elija la mejor coincidencia)"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template pinned — the AI picks the best match."
msgstr "Ninguna plantilla fijada — la IA elige la mejor coincidencia."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template pinned? The AI picks the best-matching approved template. No approved templates at all → the post-call card offers a call-back instead of dead-ending."
msgstr "¿Ninguna plantilla fijada? La IA elige la plantilla aprobada que mejor coincida. ¿Sin plantillas aprobadas? → la tarjeta posterior a la llamada ofrece una devolución de llamada en lugar de terminar."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "No templates match “{query}”."
msgstr "Ninguna plantilla coincide con “{query}”."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "No templates match \"{search}\"."
msgstr "Ninguna plantilla coincide con \"{search}\"."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "No templates yet"
msgstr "Sin plantillas aún"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "No templates yet."
msgstr "Sin plantillas aún."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "No value"
msgstr "Sin valor"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "None"
msgstr "Ninguno"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Not delivered"
msgstr "No entregado"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Not enabled"
msgstr "No habilitado"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Not routing anything to you"
msgstr "Sin enrutamientos para ti"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Note"
msgstr "Nota"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Note actions"
msgstr "Acciones de nota"

#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Note deleted"
msgstr "Nota eliminada"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Note visibility"
msgstr "Visibilidad de nota"

#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/types/v2/search.ts
msgid "Notes"
msgstr "Notas"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Nothing assigned to you right now"
msgstr "Nada asignado a ti en este momento"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Nothing assigned to you."
msgstr "Nada asignado a ti."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing completed today yet."
msgstr "Nada completado hoy aún."

#: app/frontend/components/v2/companies/activity-section.tsx
msgid "Nothing has happened at this company yet."
msgstr "Aún no ha sucedido nada en esta empresa."

#: app/frontend/components/v2/deals/deal-column.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Nothing here yet."
msgstr "Nada aquí aún."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Nothing in your inbox yet"
msgstr "Nada en tu inbox aún"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Nothing matches “{query}” yet"
msgstr "Nada coincide con “{query}” todavía"

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing on your plate right now. Enjoy the breathing room — new work shows up here as it comes in."
msgstr "Nada en tu agenda ahora. Disfruta el respiro — el trabajo nuevo aparece aquí conforme llega."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing overdue — you're caught up."
msgstr "Nada vencido — estás al día."

#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled"
msgstr "Nada programado"

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled for today yet."
msgstr "Nada programado para hoy aún."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled later this week yet."
msgstr "Nada programado para después en la semana aún."

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Nothing to chart yet — your daily telephony will appear here as you make and receive calls."
msgstr "Nada que graficar aún — tu telefonía diaria aparecerá aquí conforme hagas y recibas llamadas."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Nothing to pick yet."
msgstr "Nada que elegir aún."

#: app/frontend/components/v2/settings/team/recent-activity-card.tsx
msgid "Nothing to show yet. Once they make calls, send messages, or close deals, you'll see it here."
msgstr "Nada que mostrar aún. Una vez que hagan llamadas, envíen mensajes o cierren oportunidades, lo verás aquí."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing yet"
msgstr "Nada aún"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Nothing yet this period — your phone numbers and calls will show up here as you use them."
msgstr "Nada aún en este período — tus números de teléfono y llamadas aparecerán aquí conforme los uses."

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Notification settings"
msgstr "Ajustes de notificaciones"

#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Notifications"
msgstr "Notificaciones"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Notify me when {firstName} replies"
msgstr "Notifícame cuando {firstName} responda"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "November"
msgstr "Noviembre"

#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Number"
msgstr "Número"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Number actions"
msgstr "Acciones de número"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Numbers"
msgstr "Números"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Numbers start at {priceLabel}"
msgstr "Los números comienzan en {priceLabel}"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Numbers this teammate picks up for."
msgstr "Números que este compañero atiende."

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Numbers your team uses to call and message customers. Buy and assign them here."
msgstr "Números que tu equipo usa para llamar y enviar mensajes a clientes. Compra y asígnalos aquí."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "October"
msgstr "Octubre"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Off"
msgstr "Apagado"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Offline"
msgstr "Desconectado"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "On"
msgstr "Encendido"

#. placeholder {0}: linkedDeal.name
#. placeholder {0}: voiceCall.deal.name
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "On {0}"
msgstr "El {0}"

#: app/frontend/components/v2/inbox/header-call-button.tsx
msgid "On call"
msgstr "En llamada"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "On this deal"
msgstr "En esta oportunidad"

#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "Once a message comes in, it'll show up here."
msgstr "Una vez que llegue un mensaje, aparecerá aquí."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Once a template is approved by Meta, pin it here."
msgstr "Una vez que Meta apruebe una plantilla, fíjala aquí."

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Once you start a WhatsApp or voice conversation, the person on the other end shows up here."
msgstr "Una vez que inicies una conversación por WhatsApp o voz, la persona al otro lado aparecerá aquí."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "One header per template — text, image, video, document, or a map location."
msgstr "Un encabezado por plantilla — texto, imagen, video, documento o ubicación en mapa."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Only an approved template can send outside the 24h window. AI refills the blanks for whichever you pick."
msgstr "Solo una plantilla aprobada puede enviar fuera de la ventana de 24h. La IA rellena los espacios en blanco de la que elijas."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Only approved templates appear here."
msgstr "Solo las plantillas aprobadas aparecen aquí."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Only category and components can change. Template name and language are locked once approved. Meta usually re-approves in under 30 minutes."
msgstr "Solo la categoría y los componentes pueden cambiar. El nombre y el idioma de la plantilla se bloquean una vez aprobados. Meta generalmente vuelve a aprobar en menos de 30 minutos."

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/search/palette-footer.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Open"
msgstr "Abierto"

#. placeholder {0}: template.name
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Open {0}"
msgstr "Abrir {0}"

#. placeholder {0}: company.name
#. placeholder {0}: deal.company.name
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Open {0} details"
msgstr "Abrir detalles de {0}"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Open account menu"
msgstr "Abrir menú de cuenta"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Open availability menu"
msgstr "Abrir menú de disponibilidad"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Open call"
msgstr "Llamada abierta"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Open call →"
msgstr "Llamada abierta →"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "Open chat"
msgstr "Abrir chat"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Open chat (coming soon)"
msgstr "Abrir chat (próximamente)"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-card.tsx
msgid "Open deal: {0}"
msgstr "Abrir oportunidad: {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Open deals"
msgstr "Oportunidades abiertas"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Open filter builder"
msgstr "Abrir constructor de filtros"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "Open filter panel"
msgstr "Abrir panel de filtros"

#: app/frontend/components/v2/drawer/drawer-header.tsx
#: app/frontend/components/v2/drawer/drawer-header.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Open full page"
msgstr "Abrir página completa"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Open in WhatsApp Business"
msgstr "Abrir en WhatsApp Business"

#: app/frontend/components/v2/chrome/mobile-top-bar.tsx
msgid "Open navigation"
msgstr "Abrir navegación"

#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/chrome/notifications-bell.tsx
msgid "Open notifications"
msgstr "Abrir notificaciones"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Open question"
msgstr "Pregunta abierta"

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Open send actions"
msgstr "Abrir acciones de envío"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Opened"
msgstr "Abierto"

#: app/frontend/lib/commands.ts
msgid "Opens form"
msgstr "Abre formulario"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Opens your mail app · won't be logged"
msgstr "Abre tu aplicación de correo · no se registrará"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Opportunity created"
msgstr "Oportunidad creada"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Opportunity name"
msgstr "Nombre de la oportunidad"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "optional"
msgstr "opcional"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Optional components"
msgstr "Componentes opcionales"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Or run a command"
msgstr "O ejecuta un comando"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "or with email"
msgstr "o con correo"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Other ways to reach {firstName}"
msgstr "Otras formas de contactar a {firstName}"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Outcome"
msgstr "Resultado"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Outcome — change if the AI got it wrong"
msgstr "Resultado — cambia si la IA se equivocó"

#. placeholder {0}: i18n._(STAGE_TYPE_LABEL[stageType])
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Outcome: {0}. Click to change."
msgstr "Resultado: {0}. Haz clic para cambiar."

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Outgoing call"
msgstr "Llamada saliente"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Outgoing message"
msgstr "Mensaje saliente"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Outside the 24-hour window"
msgstr "Fuera de la ventana de 24 horas"

#: app/frontend/pages/v2/today/show.tsx
msgid "Overdue"
msgstr "Vencido"

#: app/frontend/components/v2/companies/show-tabs.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Overview"
msgstr "Resumen"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Owned by"
msgstr "Responsable"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/contact-assignees-row.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Owner"
msgstr "Responsable"

#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
msgid "Password"
msgstr "Contraseña"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Password reset is coming soon"
msgstr "El cambio de contraseña estará disponible pronto"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Pause"
msgstr "Pausar"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Pause access"
msgstr "Pausar acceso"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Pause access for {0}?"
msgstr "¿Pausar el acceso de {0}?"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Pause AI"
msgstr "Pausar IA"

#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Pause recording"
msgstr "Pausar grabación"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Pause this channel"
msgstr "Pausar este canal"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Pause this number"
msgstr "Pausar este número"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "PDF, DOCX, XLSX · up to 16 MB"
msgstr "PDF, DOCX, XLSX · hasta 16 MB"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pending"
msgstr "Pendiente"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Pending invites"
msgstr "Invitaciones pendientes"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pending review"
msgstr "Pendiente de revisión"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "People"
msgstr "Personas"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "People · {totalCount}"
msgstr "Personas · {totalCount}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Personal note"
msgstr "Nota personal"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
msgid "Personal shortcuts · sendable in window"
msgstr "Atajos personales · enviables en la ventana"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
msgid "Personal shortcuts. Sendable any time within the 24h window."
msgstr "Atajos personales. Se pueden enviar en cualquier momento dentro de la ventana de 24h."

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Phone"
msgstr "Teléfono"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Phone numbers"
msgstr "Números telefónicos"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Phone numbers and call usage."
msgstr "Números telefónicos y uso de llamadas."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Photo"
msgstr "Foto"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Photo from library"
msgstr "Foto de la galería"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Pick a conversation"
msgstr "Selecciona una conversación"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Pick a date"
msgstr "Selecciona una fecha"

#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Pick a date & time…"
msgstr "Selecciona fecha y hora…"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Pick a due date"
msgstr "Selecciona una fecha de vencimiento"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Pick a filter below to start narrowing down contacts."
msgstr "Selecciona un filtro para empezar a reducir contactos."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Pick a filter below to start narrowing down deals."
msgstr "Selecciona un filtro para empezar a reducir oportunidades."

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Pick a plan below. Cancel anytime."
msgstr "Selecciona un plan. Puedes cancelar en cualquier momento."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "Pick a recipient to continue"
msgstr "Selecciona un destinatario para continuar"

#: app/frontend/types/v2/buy-number.ts
msgid "Pick a region"
msgstr "Elige una región"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Pick a state or metro area. This sets the area code your customers will see."
msgstr "Selecciona un estado o área metropolitana. Esto establece el código de área que verán tus clientes."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/compose/template-body.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
msgid "Pick a template"
msgstr "Selecciona una plantilla"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Pick another"
msgstr "Selecciona otro"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "Pick any number that should ring this teammate's phone alongside the AI assistant."
msgstr "Selecciona cualquier número que debe sonar en el teléfono de este compañero junto con el asistente de IA."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Pick anyone who should ring when this number gets a call or message."
msgstr "Selecciona a quién debe sonarle cuando este número recibe una llamada o mensaje."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Pick at least one. You can add more later, but capabilities can't be removed once a number is purchased."
msgstr "Selecciona al menos uno. Puedes agregar más después, pero las capacidades no se pueden eliminar una vez que se compra un número."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
msgid "Pick close date"
msgstr "Selecciona la fecha de cierre"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Pick date"
msgstr "Selecciona fecha"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Pick date & time"
msgstr "Selecciona fecha y hora"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Pick emoji"
msgstr "Selecciona un emoji"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Pick snooze date and time"
msgstr "Selecciona la fecha y hora de posposición"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
msgid "Pick the teammates who own this {entityLabel}."
msgstr "Selecciona los compañeros que son responsables de este {entityLabel}."

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Pipeline"
msgstr "Embudo"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Pipeline name"
msgstr "Nombre del embudo"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/mobile-stage-tabs.tsx
msgid "Pipeline stages"
msgstr "Etapas del embudo"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Pipeline value"
msgstr "Valor del embudo"

#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Plan & billing"
msgstr "Plan y facturación"

#: app/frontend/lib/settings-nav.ts
msgid "Plan, payment method, and invoices."
msgstr "Plan, método de pago e facturas."

#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Play recording"
msgstr "Reproducir grabación"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Popular"
msgstr "Popular"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Portuguese (Brazil)"
msgstr "Portugués (Brasil)"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Positive"
msgstr "Positivo"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Post-call card preview"
msgstr "Vista previa de la tarjeta posterior a la llamada"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Post-call follow-up template"
msgstr "Plantilla de seguimiento posterior a la llamada"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pre-approved messages for sending outside the 24-hour window. Synced from Meta every 5 minutes."
msgstr "Mensajes pre-aprobados para enviar fuera de la ventana de 24 horas. Sincronizados desde Meta cada 5 minutos."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Preview"
msgstr "Vista previa"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Preview — not actually sent"
msgstr "Vista previa — no se envía realmente"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Previous month"
msgstr "Mes anterior"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Pricing"
msgstr "Precios"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Primary"
msgstr "Principal"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Primary contact"
msgstr "Contacto principal"

#: app/frontend/components/v2/auth/auth-layout.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Privacy"
msgstr "Privacidad"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Private"
msgstr "Privado"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Priya Mehta"
msgstr "Mariana López"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Product"
msgstr "Producto"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/lib/settings-nav.ts
msgid "Profile"
msgstr "Perfil"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Profile photo"
msgstr "Foto de perfil"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Properties"
msgstr "Propiedades"

#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Quick note"
msgstr "Nota rápida"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "quick replies"
msgstr "respuestas rápidas"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
msgid "Quick replies"
msgstr "Respuestas rápidas"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Quick reply"
msgstr "Respuesta rápida"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Quick reply button text"
msgstr "Texto del botón de respuesta rápida"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Read"
msgstr "Leído"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Reading this conversation…"
msgstr "Leyendo esta conversación…"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Reassign"
msgstr "Reasignar"

#. placeholder {0}: assignee.name
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Reassign — currently {0}"
msgstr "Reasignar — actualmente {0}"

#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
msgid "Reassign conversation"
msgstr "Reasignar conversación"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Reassign owner"
msgstr "Reasignar responsable"

#: app/frontend/types/v2/deal-filters.ts
msgid "Recency"
msgstr "Reciente"

#: app/frontend/components/v2/inbox/template-picker.tsx
#: app/frontend/components/v2/search/cold-start.tsx
msgid "Recent"
msgstr "Reciente"

#: app/frontend/components/v2/companies/activity-section.tsx
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/settings/team/recent-activity-card.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Recent activity"
msgstr "Actividad reciente"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Recent searches"
msgstr "Búsquedas recientes"

#: app/frontend/components/v2/settings/phone-numbers/buy/teammate-row.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Recommended"
msgstr "Recomendado"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Reconnect"
msgstr "Reconectar"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Reconnecting…"
msgstr "Reconectando…"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Record calls"
msgstr "Grabar llamadas"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Record up to 3 minutes"
msgstr "Grabar hasta 3 minutos"

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Refresh numbers"
msgstr "Actualizar números"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Regenerate AI"
msgstr "Regenerar IA"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Regenerate AI summary"
msgstr "Regenerar resumen de IA"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Regenerating the summary…"
msgstr "Regenerando el resumen…"

#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Region"
msgstr "Región"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Rejected"
msgstr "Rechazado"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Rejected and paused templates can be edited unlimited times"
msgstr "Las plantillas rechazadas y pausadas se pueden editar sin límite"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Release number"
msgstr "Número de lanzamiento"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Remove"
msgstr "Eliminar"

#. placeholder {0}: number.label ?? number.phoneNumber
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Remove {0}"
msgstr "Eliminar {0}"

#. placeholder {0}: contact.displayName
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Remove {0} from deal"
msgstr "Quitar a {0} de la oportunidad"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Remove {0}?"
msgstr "¿Eliminar {0}?"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
msgid "Remove {query} from recent searches"
msgstr "Eliminar {query} de búsquedas recientes"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Remove button"
msgstr "Botón eliminar"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Remove contact"
msgstr "Eliminar contacto"

#: app/frontend/components/v2/contacts/active-filter-chips.tsx
msgid "Remove filter"
msgstr "Eliminar filtro"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Remove from deal"
msgstr "Quitar de la oportunidad"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Remove media"
msgstr "Eliminar medios"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Remove stage"
msgstr "Eliminar etapa"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Remove teammate"
msgstr "Eliminar integrante"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Remove this filter"
msgstr "Eliminar este filtro"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Remove this number from Conecto. You'll have to reconnect from Meta to use it again."
msgstr "Elimina este número de Conecto. Tendrás que reconectar desde Meta para usarlo nuevamente."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Rename deal"
msgstr "Renombrar oportunidad"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Rename, reorder, or change stages — you can edit these later in Settings."
msgstr "Renombra, reordena o cambia las etapas — puedes editarlas después en Ajustes."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Rendered preview"
msgstr "Vista previa renderizada"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Reopen conversation"
msgstr "Reabrir conversación"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Reopens the 24h window to free-text"
msgstr "Reabre la ventana de 24h para texto libre"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Reorder stage"
msgstr "Reordenar etapa"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Replace"
msgstr "Reemplazar"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Reply to story mentions, DMs, and comments from one place."
msgstr "Responde a menciones, DMs y comentarios desde un solo lugar."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Require"
msgstr "Requerir"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Reset"
msgstr "Restablecer"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Reset to AI summary"
msgstr "Restablecer al resumen de IA"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Resolved"
msgstr "Resuelto"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Resubmitting…"
msgstr "Reenviando…"

#: app/frontend/components/v2/deals/ai-paused-banner.tsx
msgid "Resume AI"
msgstr "Reanudar IA"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Review AI draft"
msgstr "Revisar borrador de IA"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Revokes seat. Owned data stays with the workspace."
msgstr "Revoca el asiento. Los datos propios se quedan con el espacio de trabajo."

#: app/frontend/components/v2/settings/team/access-card.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
msgid "Role"
msgstr "Rol"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Routing"
msgstr "Enrutamiento"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Routing calls + messages"
msgstr "Enrutamiento de llamadas + mensajes"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Sa"
msgstr "Sá"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Sales pipeline"
msgstr "Embudo de ventas"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample · e.g. Alice"
msgstr "Ejemplo · p.ej. Alice"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample · e.g. Order #1234"
msgstr "Ejemplo · p.ej. Pedido #1234"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample code"
msgstr "Código de ejemplo"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample value for variable {n}"
msgstr "Valor de ejemplo para la variable {n}"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sample values applied"
msgstr "Valores de ejemplo aplicados"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sample values used in the preview →"
msgstr "Valores de ejemplo usados en la vista previa →"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/mobile-row-inline-editor.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Save"
msgstr "Guardar"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Save · Resubmit to Meta"
msgstr "Guardar · Reenviar a Meta"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Save a combination of filters and it shows up here for one-tap reuse."
msgstr "Guarda una combinación de filtros y aparecerá aquí para reutilizar con un toque."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Save as view"
msgstr "Guardar como vista"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Save changes"
msgstr "Guardar cambios"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Save current as view"
msgstr "Guardar actual como vista"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Save current filters as a view"
msgstr "Guardar filtros actuales como una vista"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Save draft"
msgstr "Guardar borrador"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Save next step"
msgstr "Guardar siguiente paso"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Save note"
msgstr "Guardar nota"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Saved as draft · {savedAge}"
msgstr "Guardado como borrador · {savedAge}"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Saved views"
msgstr "Vistas guardadas"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Saves on blur"
msgstr "Se guarda al desenfocarse"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Saving…"
msgstr "Guardando…"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Schedule 9:00 AM"
msgstr "Programar 9:00 AM"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Schedule a call-back"
msgstr "Programar una devolución de llamada"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Schedule a follow-up, pitch, or close action with a due date."
msgstr "Programa un seguimiento, propuesta o acción de cierre con una fecha de vencimiento."

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Schedule for 9:00 AM"
msgstr "Programar para 9:00 AM"

#: app/frontend/components/v2/contacts/contact-activity-scope-row.tsx
msgid "Scope"
msgstr "Alcance"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Search"
msgstr "Buscar"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Search {totalCount} approved templates…"
msgstr "Buscar {totalCount} plantillas aprobadas…"

#: app/frontend/components/v2/search/palette-footer.tsx
msgid "Search across your workspace"
msgstr "Busca en tu espacio de trabajo"

#: app/frontend/components/v2/search/search-input.tsx
msgid "Search anything, or type > for commands"
msgstr "Busca cualquier cosa, o escribe > para comandos"

#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Search by contact name, phone number, or anything that came up in a recent message."
msgstr "Busca por nombre de contacto, número de teléfono, o cualquier cosa que aparezca en un mensaje reciente."

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Search by deal title, company, or contact name."
msgstr "Busca por título de oportunidad, empresa, o nombre de contacto."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search by name, phone, or email. Pasted numbers are auto-validated."
msgstr "Busca por nombre, teléfono, o correo. Los números pegados se validan automáticamente."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search by name, phone, or paste a number"
msgstr "Busca por nombre, teléfono, o pega un número"

#: app/frontend/components/v2/settings/phone-numbers/search-input.tsx
msgid "Search by number, region, or assignee…"
msgstr "Busca por número, región, o asignado a…"

#: app/frontend/components/v2/companies/search-input.tsx
msgid "Search companies"
msgstr "Buscar empresas"

#: app/frontend/components/v2/companies/search-input.tsx
msgid "Search companies…"
msgstr "Buscar empresas…"

#: app/frontend/components/v2/contacts/search-input.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search contacts"
msgstr "Buscar contactos"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Search contacts at {companyName}…"
msgstr "Buscar contactos en {companyName}…"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Search contacts by name, email, or phone…"
msgstr "Buscar contactos por nombre, correo, o teléfono…"

#: app/frontend/components/v2/contacts/search-input.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Search contacts…"
msgstr "Buscar contactos…"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Search conversations"
msgstr "Buscar conversaciones"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Search countries"
msgstr "Buscar países"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Search deals"
msgstr "Buscar oportunidades"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Search deals, companies, contacts…"
msgstr "Buscar oportunidades, empresas, contactos…"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Search deals…"
msgstr "Buscar oportunidades…"

#: app/frontend/components/v2/deals/timeline-search-field.tsx
msgid "Search messages, notes & calls…"
msgstr "Buscar mensajes, notas y llamadas…"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Search numbers"
msgstr "Buscar números"

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Search opportunities"
msgstr "Buscar oportunidades"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Search or run a command"
msgstr "Busca o ejecuta un comando"

#: app/frontend/components/v2/search/search-input.tsx
msgid "Search or type > for commands"
msgstr "Busca o escribe > para comandos"

#: app/frontend/components/v2/settings/phone-numbers/search-input.tsx
msgid "Search phone numbers"
msgstr "Buscar números de teléfono"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Search quick replies"
msgstr "Buscar respuestas rápidas"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Search regions"
msgstr "Buscar regiones"

#. placeholder {0}: results.length
#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Search results ({0})"
msgstr "Resultados de búsqueda ({0})"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Search shortcuts or content…"
msgstr "Buscar atajos o contenido…"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Search states or metros"
msgstr "Buscar estados o metros"

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search team"
msgstr "Buscar equipo"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search teammates"
msgstr "Buscar integrantes"

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search teammates by name, email, or role…"
msgstr "Buscar integrantes por nombre, correo, o rol…"

#: app/frontend/components/v2/inbox/compose/composer-templates.tsx
#: app/frontend/components/v2/inbox/template-picker.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Search templates"
msgstr "Buscar plantillas"

#: app/frontend/components/v2/inbox/compose/composer-templates.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Search templates…"
msgstr "Buscar plantillas…"

#: app/frontend/components/v2/deals/timeline-search-field.tsx
msgid "Search timeline"
msgstr "Buscar línea de tiempo"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Searching…"
msgstr "Buscando…"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Seat plan billed separately."
msgstr "Plan de asientos facturado por separado."

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
#~ msgid "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page."
#~ msgstr "Los asientos se facturan por integrante. La telefonía y el consumo de IA se facturan por separado y aparecen en tu página de Consumo."

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
msgid "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page. Prices include 16% IVA."
msgstr "Los lugares se cobran por miembro del equipo. La telefonía y el uso de IA se cobran por separado y aparecen en tu página de Uso. Los precios incluyen 16% de IVA."

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Security"
msgstr "Seguridad"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "See all"
msgstr "Ver todo"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "See all notifications →"
msgstr "Ver todas las notificaciones →"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "See all options"
msgstr "Ver todas las opciones"

#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Seek recording (arrow keys to scrub)"
msgstr "Busca en la grabación (usa las flechas para navegar)"

#. placeholder {0}: item.title
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Select {0}"
msgstr "Selecciona {0}"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Select a template to preview it here."
msgstr "Selecciona una plantilla para previsualizarla aquí."

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Select a thread on the left to read the transcript and reply."
msgstr "Selecciona un hilo a la izquierda para leer la transcripción y responder."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Select all"
msgstr "Seleccionar todo"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Select…"
msgstr "Selecciona…"

#. placeholder {0}: selectedRows.length
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "Selected · {0}"
msgstr "Seleccionado · {0}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Selected now"
msgstr "Seleccionado ahora"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Send"
msgstr "Enviar"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Send a template"
msgstr "Envía una plantilla"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Send and receive messages, voice notes, and templates from your business number."
msgstr "Envía y recibe mensajes, notas de voz y plantillas desde tu número de negocio."

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Send invites and manage seats."
msgstr "Envía invitaciones y administra asientos."

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Send message"
msgstr "Enviar mensaje"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Send now"
msgstr "Enviar ahora"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Send template"
msgstr "Enviar plantilla"

#: app/frontend/components/v2/inbox/compose/channel-chips.tsx
msgid "Send via"
msgstr "Enviar por"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Send WhatsApp"
msgstr "Enviar por WhatsApp"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Sendable in window"
msgstr "Se puede enviar dentro de la ventana"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Sending as template"
msgstr "Enviando como plantilla"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Sending…"
msgstr "Enviando…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sends"
msgstr "Envía"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Sends from your phone · won't be logged"
msgstr "Envía desde tu teléfono · no se registrará"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Sent from WhatsApp Business app"
msgstr "Enviado desde la app WhatsApp Business"

#: app/frontend/components/v2/voice/sentiment.tsx
msgid "Sentiment: {sentiment} — AI-detected"
msgstr "Sentimiento: {sentiment} — detectado por IA"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "September"
msgstr "Septiembre"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Set 4 months ago"
msgstr "Establecido hace 4 meses"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Set a date"
msgstr "Establece una fecha"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Set method"
msgstr "Establecer método"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Set up a pipeline to start tracking deals through your sales process."
msgstr "Configura un embudo para comenzar a rastrear oportunidades a través de tu proceso de ventas."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Setting up…"
msgstr "Configurando…"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/overview/show.tsx
#: app/frontend/pages/v2/settings/overview/show.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Settings"
msgstr "Ajustes"

#. placeholder {0}: number.sharedWith
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Shared with {0} teammates"
msgstr "Compartido con {0} compañeros"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Shared with 1 teammate"
msgstr "Compartido con 1 compañero"

#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Show all"
msgstr "Mostrar todo"

#. placeholder {0}: regions.length
#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Show all {0} states →"
msgstr "Mostrar todos los {0} estados →"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Show all {itemCount}"
msgstr "Mostrar todos los {itemCount}"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Show all → Today"
msgstr "Mostrar todo → Hoy"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Show all teammates →"
msgstr "Mostrar todos los compañeros →"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Show dial pad"
msgstr "Mostrar teclado"

#. placeholder {0}: dismissed.length
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Show dismissed ({0}) →"
msgstr "Mostrar descartados ({0}) →"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Show less"
msgstr "Mostrar menos"

#: app/frontend/components/v2/auth/auth-text-field.tsx
msgid "Show password"
msgstr "Mostrar contraseña"

#. placeholder {0}: contacts.length
#. placeholder {1}: filters.search
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing {0} {contactNoun} for \"{1}\"."
msgstr "Mostrando {0} {contactNoun} para \"{1}\"."

#. placeholder {0}: contacts.length
#. placeholder {1}: filters.conditions.length
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing {0} {contactNoun} matching {1} {filterNoun}."
msgstr "Mostrando {0} {contactNoun} que coinciden con {1} {filterNoun}."

#. placeholder {0}: picker.filtered.length
#. placeholder {1}: templates.length
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
msgid "Showing {0} of {1}"
msgstr "Mostrando {0} de {1}"

#. placeholder {0}: picker.filtered.length
#. placeholder {1}: templates.length
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
msgid "Showing {0} of {1} · scroll for more"
msgstr "Mostrando {0} de {1} · desplázate para más"

#. placeholder {0}: stats.totalContacts
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing all {0} {totalNoun}."
msgstr "Mostrando todos los {0} {totalNoun}."

#: app/frontend/components/v2/landing/landing-nav.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign in"
msgstr "Iniciar sesión"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign in to Conecto and keep your AI on duty."
msgstr "Inicia sesión en Conecto y mantén tu IA en servicio."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Sign out"
msgstr "Cerrar sesión"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign up"
msgstr "Registrarse"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Sign-in, sessions, and account safety."
msgstr "Inicio de sesión, sesiones y seguridad de la cuenta."

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "Six stages from first contact to closed — rename, reorder, or change outcomes anytime."
msgstr "Seis etapas de primer contacto a cerrado — renombra, reordena o cambia los resultados en cualquier momento."

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Size"
msgstr "Tamaño"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Small text under the body, e.g. legal disclaimer."
msgstr "Texto pequeño bajo el cuerpo, por ejemplo descargo de responsabilidad legal."

#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/phone-number-display.ts
msgid "SMS"
msgstr "SMS"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Snooze"
msgstr "Posponer"

#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Snooze conversation"
msgstr "Posponer conversación"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Snooze until then"
msgstr "Posponer hasta entonces"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Snooze…"
msgstr "Posponer…"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Snoozed"
msgstr "Pospuesto"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Something went wrong creating the deal — try again."
msgstr "Algo salió mal al crear la oportunidad — intenta de nuevo."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Something went wrong sending this. Try a different way to reach them."
msgstr "Algo salió mal al enviar esto. intenta una forma diferente de contactarlos."

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "Something went wrong. Please try again."
msgstr "Algo salió mal. por favor intenta de nuevo."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Something went wrong. Try reconnecting."
msgstr "Algo salió mal. intenta reconectarte."

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Soon"
msgstr "Pronto"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
msgid "Sort by"
msgstr "Ordenar por"

#: app/frontend/components/v2/companies/index-toolbar.tsx
msgid "Sort companies"
msgstr "Ordenar empresas"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Sort results"
msgstr "Ordenar resultados"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Source"
msgstr "Origen"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Source for variable {n}"
msgstr "Origen para la variable {n}"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Spanish (Mexico)"
msgstr "Español (México)"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Spin up your AI sales rep in under two minutes."
msgstr "Activa tu agente de ventas de IA en menos de dos minutos."

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
msgid "Spoke with @maya about the 18% counter…"
msgstr "Hablé con @maya sobre la propuesta del 18%…"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Staff"
msgstr "Personal"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Stage"
msgstr "Etapa"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stage name"
msgstr "Nombre de la etapa"

#. placeholder {0}: deal.stage.name
#: app/frontend/components/v2/deals/stage-picker.tsx
msgid "Stage: {0}. Click to change."
msgstr "Etapa: {0}. haz clic para cambiar."

#. placeholder {0}: deal.stage.name
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
msgid "Stage: {0}. Tap to change."
msgstr "Etapa: {0}. toca para cambiar."

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stages"
msgstr "Etapas"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stages can be reordered anytime."
msgstr "Las etapas se pueden reordenar en cualquier momento."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Start 14-day trial"
msgstr "Inicia prueba de 14 días"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Start for free"
msgstr "Empieza gratis"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "Start free"
msgstr "Empieza gratis"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Start free trial"
msgstr "Inicia prueba gratis"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Start new conversation"
msgstr "Inicia nueva conversación"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Start typing to search your contacts."
msgstr "Comienza a escribir para buscar tus contactos."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Start with {phone}"
msgstr "Empieza con {phone}"

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Start your 14-day free trial"
msgstr "Inicia tu prueba gratuita de 14 días"

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Start your free trial today"
msgstr "Inicia tu prueba gratuita hoy"

#: app/frontend/types/v2/contact-filters.ts
msgid "State"
msgstr "Estado"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Status"
msgstr "Estado"

#: app/frontend/lib/conversation-formatting.ts
msgid "Sticker"
msgstr "Sticker"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Strikethrough"
msgstr "Tachado"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Su"
msgstr "Do"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Submit to Meta for approval"
msgstr "Envía a Meta para aprobación"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Submitting…"
msgstr "Enviando…"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Suggestion dismissed"
msgstr "Sugerencia descartada"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Summary"
msgstr "Resumen"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Switch anytime — upgrades are prorated, downgrades apply next cycle."
msgstr "Cambia en cualquier momento — los aumentos son prorrateados, las reducciones se aplican el siguiente ciclo."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Switch back to All to see every conversation, or wait for one to be assigned to you."
msgstr "Regresa a Todos para ver todas las conversaciones, o espera a que se te asigne una."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Switch categories or create a new template from Settings."
msgstr "Cambia de categoría o crea una plantilla nueva desde Ajustes."

#. placeholder {0}: plan.name
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Switch to {0}"
msgstr "Cambiar a {0}"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sync from Meta"
msgstr "Sincronizar desde Meta"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Synced {syncedAge}"
msgstr "Sincronizado hace {syncedAge}"

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "System"
msgstr "Sistema"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Tag"
msgstr "Etiqueta"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Tag suggestions"
msgstr "Sugerencias de etiquetas"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Tags"
msgstr "Etiquetas"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Take a photo"
msgstr "Tomar una foto"

#: app/frontend/components/v2/today/mobile-tabs.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Team"
msgstr "Equipo"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Team access"
msgstr "Acceso del equipo"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Team size"
msgstr "Tamaño del equipo"

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Teammate"
msgstr "Compañero de equipo"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Teammates"
msgstr "Compañeros de equipo"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Teammates can @mention you in notes."
msgstr "Los compañeros de equipo pueden mencionarte con @ en las notas."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Teammates who can see and reply to conversations on this channel."
msgstr "Compañeros de equipo que pueden ver y responder a conversaciones en este canal."

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Telephony only."
msgstr "Solo telefonía."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Template"
msgstr "Plantilla"

#. placeholder {0}: draft.templateName
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Template · {0}"
msgstr "Plantilla · {0}"

#. placeholder {0}: template.name
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "TEMPLATE · {0}"
msgstr "PLANTILLA · {0}"

#. placeholder {0}: draft.templateName
#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Template · {0} · approved"
msgstr "Plantilla · {0} · aprobada"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template actions"
msgstr "Acciones de plantilla"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Template category"
msgstr "Categoría de plantilla"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template ID"
msgstr "ID de plantilla"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template name"
msgstr "Nombre de plantilla"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Template variable {0}"
msgstr "Variable de plantilla {0}"

#: app/frontend/components/v2/inbox/compose/template-body.tsx
msgid "Template variable {number}"
msgstr "Variable de plantilla {number}"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Template variable {token}"
msgstr "Variable de plantilla {token}"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "templates"
msgstr "plantillas"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Templates"
msgstr "Plantillas"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Templates are managed in Settings → WhatsApp."
msgstr "Las plantillas se gestionan en Ajustes → WhatsApp."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Templates are pre-approved messages you can send outside the 24-hour customer service window. Meta reviews each one before approval."
msgstr "Las plantillas son mensajes preaprobados que puedes enviar fuera de la ventana de servicio al cliente de 24 horas. Meta revisa cada una antes de aprobarla."

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Temporarily revoke sign-in without removing data."
msgstr "Revoca el acceso temporalmente sin borrar los datos."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Temporarily stop sending and receiving messages on this number."
msgstr "Detén temporalmente el envío y la recepción de mensajes en este número."

#: app/frontend/components/v2/auth/auth-layout.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Terms"
msgstr "Términos"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Test call"
msgstr "Llamada de prueba"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Text"
msgstr "Texto"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Text formatting"
msgstr "Formato de texto"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Th"
msgstr "Ju"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "That doesn't look like a number."
msgstr "Eso no parece un número."

#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "That suggestion changed — take another look."
msgstr "Esa sugerencia cambió — échale otro vistazo."

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "The AI-native CRM for teams that sell on WhatsApp. Built for how LATAM does business."
msgstr "El CRM nativo de IA para equipos que venden en WhatsApp. Construido para cómo hace negocios LATAM."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "The attachment couldn't be uploaded"
msgstr "No se pudo cargar el archivo adjunto"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The avatar shown on outbound conversations."
msgstr "El avatar que se muestra en las conversaciones salientes."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "The carrier rejected delivery, or this number isn't on WhatsApp anymore. Try another channel or double-check the number on the contact card."
msgstr "El proveedor rechazó la entrega, o este número ya no está en WhatsApp. Intenta otro canal o verifica de nuevo el número en la tarjeta de contacto."

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "The CRM that works while you sell"
msgstr "El CRM que funciona mientras vendes"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "The moment someone messages, Conecto creates the contact, enriches it, and opens a deal — before you've even read the chat."
msgstr "En el momento en que alguien envía un mensaje, Conecto crea el contacto, lo enriquece y abre una oportunidad — antes de que hayas leído el chat."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The name shown in your inbox and shared with teammates."
msgstr "El nombre que se muestra en tu inbox y se comparte con los compañeros de equipo."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "The number couldn't be reached. You weren't charged."
msgstr "No se pudo comunicar con el número. No se te cobró."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The phone number Meta has verified for this account."
msgstr "El número de teléfono que Meta ha verificado para esta cuenta."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "The pin is set per message, at send time"
msgstr "El pin se establece por mensaje, en el momento del envío"

#: app/frontend/components/v2/landing/testimonials.tsx
msgid "The teams who switched aren't going back"
msgstr "Los equipos que cambiaron no van a volver"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Their reply reopens the 24h window — you'll be able to free-text then."
msgstr "Su respuesta reabre la ventana de 24h — podrás enviar texto libre entonces."

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Theme"
msgstr "Tema"

#. placeholder {0}: preview.recurringLabel
#. placeholder {1}: preview.renewalDateLabel
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Then {0} · renews {1}"
msgstr "Luego {0} · se renueva {1}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "There's no WhatsApp conversation with {contactName} yet — start one from the inbox to send a follow-up."
msgstr "Aún no hay una conversación de WhatsApp con {contactName} — comienza una desde el inbox para enviar un seguimiento."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "These were captured before the deal existed. They'll stay on {stayOnTarget} either way."
msgstr "Estos fueron capturados antes de que existiera la oportunidad. Se quedarán en {stayOnTarget} de cualquier forma."

#: app/frontend/pages/v2/companies/index.tsx
msgid "They'll appear here as you talk to people from the same workplace."
msgstr "Aparecerán aquí mientras hablas con personas del mismo lugar de trabajo."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "this contact"
msgstr "este contacto"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "This deal and its history will be permanently deleted."
msgstr "Esta oportunidad y su historial se eliminarán permanentemente."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "This message was deleted"
msgstr "Este mensaje fue eliminado"

#: app/frontend/lib/usage-props.ts
msgid "This month"
msgstr "Este mes"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "this period"
msgstr "este período"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "This period so far"
msgstr "Este período hasta ahora"

#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "This teammate can place and receive calls."
msgstr "Este compañero de equipo puede hacer y recibir llamadas."

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "This teammate isn't answering on any numbers yet."
msgstr "Este compañero de equipo aún no está respondiendo en ningún número."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "This template doesn't use any variables."
msgstr "Esta plantilla no usa ninguna variable."

#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "this week"
msgstr "esta semana"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "This will revoke their seat. Conversations and deals they own will stay in the workspace."
msgstr "Esto revocará su asiento. Las conversaciones y oportunidades que poseen permanecerán en el espacio de trabajo."

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "This will revoke their sign-in until you turn it back on. Conversations and deals they own stay put."
msgstr "Esto revocará su acceso hasta que lo vuelvas a activar. Las conversaciones y oportunidades que poseen se mantienen en su lugar."

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Time"
msgstr "Hora"

#: app/frontend/components/v2/settings/team/profile-card.tsx
msgid "Timezone"
msgstr "Zona horaria"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Title"
msgstr "Título"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "to send"
msgstr "para enviar"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "today"
msgstr "hoy"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/landing/feature-today.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Today"
msgstr "Hoy"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Today at 9:14 AM · Chrome"
msgstr "Hoy a las 9:14 AM · Chrome"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle buttons component"
msgstr "Componente de botones de alternar"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle footer component"
msgstr "Componente de pie de página de alternar"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle header component"
msgstr "Componente de encabezado de alternar"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Toggle note visibility"
msgstr "Alternar visibilidad de nota"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Toggle resolved variables"
msgstr "Alternar variables resueltas"

#: app/frontend/lib/settings-nav.ts
msgid "Tokens for developers and webhooks."
msgstr "Tokens para desarrolladores y webhooks."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Toll-free"
msgstr "Número gratuito"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Tomorrow"
msgstr "Mañana"

#: app/frontend/lib/settings-nav.ts
msgid "Tone, guardrails, and handoff rules."
msgstr "Tono, barreras de seguridad y reglas de entrega."

#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Total"
msgstr "Total"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Total companies"
msgstr "Total de empresas"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Total contacts"
msgstr "Total de contactos"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Total numbers"
msgstr "Total de números"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Total this period"
msgstr "Total este período"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Track a new opportunity through your pipeline"
msgstr "Sigue una nueva oportunidad a través de tu embudo"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Transcribe inbound voice notes so AI can reply to them."
msgstr "Transcribe notas de voz entrantes para que la IA pueda responder."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Transcribing this call… it'll appear here when it's ready."
msgstr "Transcribiendo esta llamada… aparecerá aquí cuando esté lista."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Transcript"
msgstr "Transcripción"

#: app/frontend/lib/settings-nav.ts
msgid "Triggers, routing, and auto-replies."
msgstr "Desencadenadores, enrutamiento y respuestas automáticas."

#: app/frontend/components/v2/landing/trust-strip.tsx
msgid "Trusted by teams that live in WhatsApp"
msgstr "Confiado por equipos que viven en WhatsApp"

#: app/frontend/components/v2/search/command-list.tsx
msgid "Try \"deal\", \"inbox\", or \"settings\"."
msgstr "Intenta \"oportunidad\", \"inbox\" o \"ajustes\"."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Try a different category or a shorter search."
msgstr "Intenta una categoría diferente o una búsqueda más corta."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Try a different name or phone number."
msgstr "Intenta un nombre o número de teléfono diferente."

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Try a different search or filter to see more."
msgstr "Intenta una búsqueda o filtro diferente para ver más."

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Try a different search."
msgstr "Intenta una búsqueda diferente."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Try a different template"
msgstr "Prueba una plantilla diferente"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Try a name, phone number, or a few words from a note."
msgstr "Prueba con un nombre, número de teléfono o algunas palabras de una nota."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Try a shorter search."
msgstr "Prueba una búsqueda más corta."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Try again"
msgstr "Intenta de nuevo"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Try searching"
msgstr "Intenta buscando"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Tu"
msgstr "Tú"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Tune prompts, automations, and templates."
msgstr "Ajusta indicaciones, automatizaciones y plantillas."

#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "Turn on to let this teammate place and receive calls."
msgstr "Activa para que este compañero pueda hacer y recibir llamadas."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Two-factor"
msgstr "Autenticación de dos factores"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Type a message…"
msgstr "Escribe un mensaje…"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Type a value"
msgstr "Escribe un valor"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Type your message…"
msgstr "Escribe tu mensaje…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Unarchive"
msgstr "Desarchiva"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inline-edit/owner-popover.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
#: app/frontend/lib/phone-number-display.ts
msgid "Unassigned"
msgstr "Sin asignar"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Uncheck"
msgstr "Desmarca"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Undo"
msgstr "Deshacer"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Undo — restore your note"
msgstr "Deshacer — restaura tu nota"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Unknown caller"
msgstr "Llamador desconocido"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "Unknown contact"
msgstr "Contacto desconocido"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
msgid "Unlink conversation"
msgstr "Desvincular conversación"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Unmute"
msgstr "Activar sonido"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Unmute notifications"
msgstr "Activar notificaciones"

#: app/frontend/components/v2/notifications/notification-row.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Unread"
msgstr "Sin leer"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/completed-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Untitled task"
msgstr "Tarea sin título"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "up to {limit}"
msgstr "hasta {limit}"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Up to 10 — quick replies, plus URL / call / copy-code actions."
msgstr "Hasta 10 — respuestas rápidas, más acciones de URL / llamada / copiar código."

#. placeholder {0}: relativeTimeLabel(summary.generatedAt)
#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Updated {0}"
msgstr "Actualizado {0}"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Updates"
msgstr "Actualizaciones"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Updating…"
msgstr "Actualizando…"

#. placeholder {0}: plan.name
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Upgrade to {0}"
msgstr "Actualiza a {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Uploading…"
msgstr "Cargando…"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button link"
msgstr "Enlace del botón URL"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button link sample"
msgstr "Ejemplo de enlace del botón URL"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button text"
msgstr "Texto del botón URL"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Usage"
msgstr "Consumo"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Use"
msgstr "Usa"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Use {{n}} to insert variables that fill in at send time."
msgstr "Usa {{n}} para insertar variables que se completen al enviar."

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Use AI draft"
msgstr "Usa borrador de IA"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Use AI summary"
msgstr "Usa resumen de IA"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Use device camera"
msgstr "Usa la cámara del dispositivo"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Use template"
msgstr "Usa plantilla"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Used when you message a contact more than 24 hours after they last replied — WhatsApp only allows an approved template then. The AI fills the variables for you."
msgstr "Se usa cuando le escribes a un contacto más de 24 horas después de que respondió por última vez — WhatsApp solo permite una plantilla aprobada entonces. La IA completa las variables para ti."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Utility"
msgstr "Utilidad"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Value"
msgstr "Valor"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Value amount"
msgstr "Cantidad del valor"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Value can't be negative."
msgstr "El valor no puede ser negativo."

#: app/frontend/components/v2/inbox/compose/template-body.tsx
msgid "Value for {{{number}}}"
msgstr "Valor para {{{number}}}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Variables"
msgstr "Variables"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Variables marked AUTO came from the contact or linked deal. Click any value to override."
msgstr "Las variables marcadas como AUTO vinieron del contacto u oportunidad vinculada. Haz clic en cualquier valor para reemplazar."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Variables shown above are filled with sample values. At send time, they'll resolve from the linked contact and deal."
msgstr "Las variables mostradas arriba se completan con valores de ejemplo. Al enviar, se resolverán desde el contacto y oportunidad vinculados."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Variables shown are filled with sample values. At send time, they resolve from the linked contact and deal."
msgstr "Las variables mostradas se completan con valores de ejemplo. Al enviar, se resuelven desde el contacto y oportunidad vinculados."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Variables still all have sample values"
msgstr "Las variables aún tienen todos valores de ejemplo"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Verified"
msgstr "Verificado"

#. placeholder {0}: kpis.lastTouch.channel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "via {0}"
msgstr "vía {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Video"
msgstr "Video"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Video up to 16 MB · the sample Meta reviews"
msgstr "Video de hasta 16 MB · el ejemplo que Meta revisa"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "View activity"
msgstr "Ver actividad"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View company"
msgstr "Ver empresa"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View contact"
msgstr "Ver contacto"

#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#~ msgid "View contact {0}"
#~ msgstr "Ver contacto {0}"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View linked deal"
msgstr "Ver oportunidad vinculada"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "View on WhatsApp"
msgstr "Ver en WhatsApp"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "View transcript"
msgstr "Ver transcripción"

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
msgid "View usage →"
msgstr "Ver consumo →"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Visible to team"
msgstr "Visible para el equipo"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Visit URL"
msgstr "Visita URL"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/lib/phone-number-display.ts
msgid "Voice"
msgstr "Voz"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Voice & calling"
msgstr "Voz y llamadas"

#: app/frontend/lib/conversation-formatting.ts
msgid "Voice call"
msgstr "Llamada de voz"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "Voice calling"
msgstr "Llamadas de voz"

#: app/frontend/components/v2/settings/team/teammate-hero.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Voice calling is off for this teammate"
msgstr "Las llamadas de voz están desactivadas para este compañero"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice connection"
msgstr "Conexión de voz"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Voice enabled"
msgstr "Voz habilitada"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Voice is included with every number."
msgstr "La voz viene incluida con cada número."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice isn't enabled for your account"
msgstr "La voz no está habilitada para tu cuenta"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice isn't enabled for your account."
msgstr "La voz no está habilitada para tu cuenta."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Voice memo"
msgstr "Memo de voz"

#: app/frontend/lib/conversation-formatting.ts
msgid "Voice message"
msgstr "Mensaje de voz"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "Voice minutes"
msgstr "Minutos de voz"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Voice notes"
msgstr "Notas de voz"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Voice off"
msgstr "Voz desactivada"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Voice on"
msgstr "Voz activada"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Voice only · log outcome as a note"
msgstr "Solo voz · registra el resultado como una nota"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Voice seats used"
msgstr "Asientos de voz utilizados"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Voice-capable"
msgstr "Compatible con voz"

#: app/frontend/lib/voice-disposition.ts
msgid "Voicemail"
msgstr "Correo de voz"

#: app/frontend/lib/voice-disposition.ts
msgid "Voicemail — left a message"
msgstr "Correo de voz — dejó un mensaje"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Wake up to a day that's already prioritized"
msgstr "Despiértate a un día que ya está priorizado"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Want us to finish this profile?"
msgstr "¿Quieres que completemos este perfil?"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "We"
msgstr "Nosotros"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't add that. Please try again."
msgstr "No pudimos agregar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "We couldn't analyze this call."
msgstr "No pudimos analizar esta llamada."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "We couldn't attach those. Please try again."
msgstr "No pudimos adjuntar esos. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't bring that back. Please try again."
msgstr "No pudimos traer eso de vuelta. Por favor intenta de nuevo."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We couldn't calculate the total just now. We won't charge you until we can show the amount."
msgstr "No pudimos calcular el total en este momento. No te cobraremos hasta que podamos mostrarte el monto."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "We couldn't create that deal. Please try again."
msgstr "No pudimos crear esa oportunidad. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "We couldn't create that. Please try again."
msgstr "No pudimos crear eso. Inténtalo de nuevo."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't delete that. Please try again."
msgstr "No pudimos eliminar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't dismiss that. Please try again."
msgstr "No pudimos descartar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't draft a follow-up just now. Please try again in a moment."
msgstr "No pudimos redactar un seguimiento en este momento. Por favor intenta de nuevo en un momento."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't fill this template — add the details and send."
msgstr "No pudimos completar esta plantilla — agrega los detalles y envía."

#: app/frontend/pages/v2/deals/show.tsx
msgid "We couldn't find this deal."
msgstr "No pudimos encontrar esta oportunidad."

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "We couldn't link that. Please try again."
msgstr "No pudimos vincular eso. Inténtalo de nuevo."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "We couldn't load the deals. Please try again."
msgstr "No pudimos cargar las oportunidades. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't load the follow-up. Please try again."
msgstr "No pudimos cargar el seguimiento. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't move that. Please try again."
msgstr "No pudimos mover eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "We couldn't regenerate that. Please try again."
msgstr "No pudimos regenerar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't save that. Please try again."
msgstr "No pudimos guardar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't schedule that. Please try again."
msgstr "No pudimos programar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't send that. Please try again."
msgstr "No pudimos enviar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "We couldn't send this message"
msgstr "No pudimos enviar este mensaje"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't set that up. Please try again."
msgstr "No pudimos configurar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/softphone.tsx
#: app/frontend/components/v2/voice/softphone.tsx
msgid "We couldn't start the call. Please try again."
msgstr "No pudimos iniciar la llamada. Por favor intenta de nuevo."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "We couldn't transcribe this call."
msgstr "No pudimos transcribir esta llamada."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't undo that. Please try again."
msgstr "No pudimos deshacer eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't update that. Please try again."
msgstr "No pudimos actualizar eso. Por favor intenta de nuevo."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "We couldn't upload that file. Try again."
msgstr "No pudimos cargar ese archivo. Intenta de nuevo."

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "We set up a starter pipeline for you"
msgstr "Configuramos un embudo inicial para ti"

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "We'll create the contact when you send the first message."
msgstr "Crearemos el contacto cuando envíes el primer mensaje."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We'll pick a {regionName} number and connect it to your inbox. Usually live within 30 seconds."
msgstr "Elegiremos un número de {regionName} y lo conectaremos a tu inbox. Normalmente estará activo en 30 segundos."

#. placeholder {0}: data.areaCode
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We'll pick a {regionName} number with area code {0} and connect it to your inbox. Usually live within 30 seconds."
msgstr "Elegiremos un número de {regionName} con área {0} y lo conectaremos a tu inbox. Normalmente estará activo en 30 segundos."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We'll ping you when {firstName} replies"
msgstr "Te avisaremos cuando {firstName} responda"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "We're filtering the pipeline below as you type. Close to see matching deals."
msgstr "Estamos filtrando el embudo conforme escribes. Cierra para ver las oportunidades coincidentes."

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Website"
msgstr "Sitio web"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Welcome back"
msgstr "Bienvenido de nuevo"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "What came out of this call?"
msgstr "¿Cuál fue el resultado de esta llamada?"

#: app/frontend/types/v2/buy-number.ts
msgid "What can this number do?"
msgstr "¿Qué puede hacer este número?"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "What does the message say?"
msgstr "¿Qué dice el mensaje?"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "What the AI handled for you this period — at no extra cost."
msgstr "Lo que la IA resolvió por ti este período — sin costo adicional."

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "What this teammate can see and change."
msgstr "Qué puede ver y cambiar este compañero de equipo."

#: app/frontend/lib/settings-nav.ts
msgid "What you get pinged about, and how."
msgstr "Sobre qué te avisaremos y cómo."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "What's it worth? e.g. $48,000"
msgstr "¿Cuánto vale? p. ej. $48,000"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "What's the deal about?"
msgstr "¿De qué se trata la oportunidad?"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "What's the follow-up?"
msgstr "¿Cuál es el seguimiento?"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "WHAT'S THE NEXT STEP?"
msgstr "¿CUÁL ES EL SIGUIENTE PASO?"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "What's the opportunity?"
msgstr "¿De qué se trata la oportunidad?"

#: app/frontend/components/v2/contacts/row-actions.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "WhatsApp"
msgstr "WhatsApp"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "WhatsApp · {contactName}"
msgstr "WhatsApp · {contactName}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "WhatsApp · {firstName}"
msgstr "WhatsApp · {firstName}"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "WhatsApp · calls"
msgstr "WhatsApp · llamadas"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "WhatsApp Account"
msgstr "Cuenta WhatsApp"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "WhatsApp Business"
msgstr "WhatsApp Business"

#: app/frontend/components/v2/messages/outbound-sender-avatar.tsx
msgid "WhatsApp Business App"
msgstr "App WhatsApp Business"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp can't reach this number right now"
msgstr "WhatsApp no puede alcanzar este número ahora"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "WhatsApp follow-up message"
msgstr "Mensaje de seguimiento WhatsApp"

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "WhatsApp inbound"
msgstr "WhatsApp entrante"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp is rate-limiting this number"
msgstr "WhatsApp está limitando la velocidad de este número"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "WhatsApp message preview"
msgstr "Vista previa de mensaje WhatsApp"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "WhatsApp opens the 24-hour reply window once the contact replies. Freeform sends are blocked until then."
msgstr "WhatsApp abre la ventana de 24 horas para responder cuando el contacto responde. Los mensajes de forma libre se bloquean hasta entonces."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp paused this send for quality reasons"
msgstr "WhatsApp pausó este envío por razones de calidad"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp rejected the image or video. Re-attach the file and send again — large videos and unsupported formats are the most common cause."
msgstr "WhatsApp rechazó la imagen o el video. Vuelve a adjuntar el archivo y envía de nuevo — los videos grandes y los formatos no compatibles son las causas más comunes."

#: app/frontend/lib/settings-nav.ts
msgid "WhatsApp templates and quick replies."
msgstr "Plantillas y respuestas rápidas de WhatsApp."

#: app/frontend/lib/settings-nav.ts
msgid "WhatsApp, Instagram, email, and live chat."
msgstr "WhatsApp, Instagram, correo electrónico y chat en vivo."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "When"
msgstr "Cuándo"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "where"
msgstr "dónde"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Where do they work?"
msgstr "¿Dónde trabajan?"

#: app/frontend/types/v2/buy-number.ts
msgid "Where should this number be from?"
msgstr "¿De dónde debería ser este número?"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Which deal"
msgstr "¿Cuál oportunidad"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "Which numbers ring {employeeName}?"
msgstr "¿Cuáles números suenan en {employeeName}?"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Whisper next steps and objections"
msgstr "Susurra siguientes pasos y objeciones"

#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Who answers this number?"
msgstr "¿Quién contesta este número?"

#: app/frontend/lib/settings-nav.ts
msgid "Who changed what, and when."
msgstr "Quién cambió qué y cuándo."

#: app/frontend/types/v2/buy-number.ts
msgid "Who should answer this number?"
msgstr "¿Quién debería contestar este número?"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
msgid "Who's assigned?"
msgstr "¿Quién está asignado?"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Why this message:"
msgstr "Por qué este mensaje:"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "within"
msgstr "en los últimos"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Within the 24h window · free text"
msgstr "Dentro de la ventana de 24h · texto libre"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Won"
msgstr "Ganada"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "Work email"
msgstr "Correo de trabajo"

#: app/frontend/components/v2/auth/auth-submit-button.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
msgid "Working…"
msgstr "Trabajando…"

#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/lib/settings-nav.ts
msgid "Workspace"
msgstr "Espacio de trabajo"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Workspace default"
msgstr "Espacio de trabajo predeterminado"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Write a quick follow-up…"
msgstr "Escribe un seguimiento rápido…"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
#: app/frontend/lib/voice-disposition.ts
msgid "Wrong number"
msgstr "Número incorrecto"

#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Yesterday"
msgstr "Ayer"

#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
msgid "you"
msgstr "tú"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "You"
msgstr "Tú"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "You attempted to send"
msgstr "Intentaste enviar"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "You can edit any field after the contact is created"
msgstr "Puedes editar cualquier campo después de crear el contacto"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "You can edit any field after the deal is created"
msgstr "Puedes editar cualquier campo después de crear la oportunidad"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "You won't be charged until you pick a number. Cancel anytime."
msgstr "No se te cobrará hasta que elijas un número. Puedes cancelar en cualquier momento."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "You'll need an approved WhatsApp template to send while the 24-hour window is closed. Create one in Settings → Channels → WhatsApp → Templates."
msgstr "Necesitarás una plantilla de WhatsApp aprobada para enviar mientras la ventana de 24 horas está cerrada. Crea una en Ajustes → Canales → WhatsApp → Plantillas."

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "You're all caught up."
msgstr "Estás al día."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "You're all set — welcome aboard!"
msgstr "¡Todo listo — bienvenido!"

#: app/frontend/pages/v2/today/show.tsx
msgid "You're caught up"
msgstr "Estás al día"

#. placeholder {0}: pricing.baseFromLabel
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "You're on a trial. To purchase phone numbers, add a credit card. Numbers start at {0} and bill on the day you buy."
msgstr "Estás en prueba. Para comprar números de teléfono, añade una tarjeta de crédito. Los números comienzan en {0} y se facturan el día que compres."

#. placeholder {0}: current.planName ?? "free"
#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "You're on the {0} trial"
msgstr "Estás en la prueba de {0}"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "you@company.com"
msgstr "tu@empresa.com"

#: app/frontend/lib/settings-nav.ts
msgid "Your AI and telephony spend."
msgstr "Tu consumo de IA y telefonía."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Your AI assistant replies to inbound messages on this channel."
msgstr "Tu asistente de IA responde a los mensajes entrantes en este canal."

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "Your AI sales rep that lives in WhatsApp."
msgstr "Tu representante de ventas de IA que vive en WhatsApp."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "your contact"
msgstr "tu contacto"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "Your cost for all of this"
msgstr "Tu costo de todo esto"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Your day"
msgstr "Tu día"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Your draft is saved"
msgstr "Tu borrador está guardado"

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Your first charge is on {chargeDate}."
msgstr "Tu primer cargo es el {chargeDate}."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Your message will appear here."
msgstr "Tu mensaje aparecerá aquí."

#: app/frontend/lib/settings-nav.ts
msgid "Your name, email, and password."
msgstr "Tu nombre, correo electrónico y contraseña."

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Your note"
msgstr "Tu nota"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Your note · or use the AI summary once it lands"
msgstr "Tu nota · o usa el resumen de IA cuando esté listo"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Your number is assigned at purchase"
msgstr "Tu número se asigna en la compra"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Your pipeline updates while you talk"
msgstr "Tu embudo se actualiza mientras hablas"

#: app/frontend/pages/v2/settings/usage/show.tsx
msgid "Your spend and what AI handled for you this period."
msgstr "Tu consumo y lo que la IA resolvió por ti este período."
